<template>

    <div
        data-aos="fade-up"
        data-aos-delay="150"
        data-aos-anchor-placement="top"
        data-aos-duration="550"
        class="shop-single-item-container"
    >

        <div class="container px-4 px-xxl-5">
            <div class="row">
                <div class="col-24 d-flex flex-column align-items-start recycle-block">

                    <div class="d-flex align-items-center justify-content-center justify-content-xl-start mb-3 w-100">
                        <a class="nav-link h6 h5-md h6-xxl h5-xxxl mb-0 text-secondary px-0" :class="lang == 'it' ? 'text-secondary pointer-events-none' : 'text-white'" :href="lang != 'it' ? translateUrl('it', 'vini') : 'javascript:void(0)'">
                            <span class="text-smaller-sm-90">Ita</span>
                        </a>
                        <a class="nav-link h6 h5-md h6-xxl h5-xxxl mb-0 text-secondary px-0 ms-3" :class="lang == 'en' ? 'text-secondary pointer-events-none' : 'text-white'" :href="lang != 'en' ? translateUrl('en', 'vini') : 'javascript:void(0)'">
                            <span class="text-smaller-sm-90">Eng</span>
                        </a>
                        <a class="nav-link h6 h5-md h6-xxl h5-xxxl mb-0 text-secondary px-0 ms-3" :class="lang == 'fr' ? 'text-secondary pointer-events-none' : 'text-white'" :href="lang != 'fr' ? translateUrl('fr', 'vini') : 'javascript:void(0)'">
                            <span class="text-smaller-sm-90">Fra</span>
                        </a>
                        <a class="nav-link h6 h5-md h6-xxl h5-xxxl mb-0 text-secondary px-0 ms-3" :class="lang == 'de' ? 'text-secondary pointer-events-none' : 'text-white'" :href="lang != 'de' ? translateUrl('de', 'vini') : 'javascript:void(0)'">
                            <span class="text-smaller-sm-90">Deu</span>
                        </a>
                        <a class="nav-link h6 h5-md h6-xxl h5-xxxl mb-0 text-secondary px-0 ms-3 ls-container"
                            :class="!['it', 'en', 'fr', 'de'].includes(lang) ? 'text-secondary pointer-events-none' : 'text-white'"
                            :href="'javascript:void(0)'"
                            style="display:flex;flex-direction:row;align-items:baseline;position:relative;"
                            @click="openLanguageSelector"
                            @mouseenter="openLanguageSelector"
                            @mouseleave="closeLanguageSelector"
                        >
                            <div class="text-smaller-sm-90">Others</div>
                            <div class="ms-1" style="color: #fff; fill: #fff; width: 0.9rem; height: 0.9rem">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                            </div>
                            <div class="ls" :class="{'d-none': !languageSelectorOpened}">
                                <div >
                                    <a v-for="l in additionalLanguages" class="ls-item nav-link h6 h5-md h6-xxl h5-xxxl mb-0 text-secondary px-0 ms-3" :class="lang == l.id ? 'text-secondary pointer-events-none' : 'text-white'" :href="lang != l.id ? translateUrl(l.id, 'vini') : 'javascript:void(0)'">
                                        <span class="text-smaller-sm-90">{{ l.label }}</span>
                                    </a>
                                </div>
                            </div>
                        </a>
                    </div>

                    <svg class="logo mb-3 mx-auto ms-xl-0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 299.1601 18.09176" style="enable-background:new 0 0 299.1601 18.09176;" xml:space="preserve">
                        <g>
                            <path class="st0" fill="#ffffff" d="M299.07593,8.92949c-0.28079-2.46794-1.50171-4.38386-3.50562-5.79229
                                c-2.00613-1.41003-4.26114-1.8534-6.66241-1.42181c-2.17114,0.39025-3.96661,1.46555-5.31085,3.22548
                                c-1.24408,1.62872-1.80402,3.46834-1.62943,5.53225c0.16846,1.99121,0.98224,3.68863,2.39426,5.05173
                                c1.89847,1.83283,4.20322,2.66527,6.86298,2.46615c1.39331-0.10425,2.68948-0.5025,3.87387-1.23008
                                c2.04373-1.25524,3.37482-3.03415,3.86908-5.40423c0.06503-0.31216,0.12823-0.62473,0.19229-0.93709c0-0.425,0-0.85001,0-1.27501
                                C299.1312,9.07309,299.08432,9.00339,299.07593,8.92949z M294.62726,14.89035c-0.48547,0.82664-1.10602,1.53585-1.9313,2.04394
                                c-1.5412,0.94867-3.28516,0.82345-4.68069-0.33213c-1.1019-0.91232-1.80869-2.08528-2.23785-3.43419
                                c-0.80194-2.52087-0.71683-5.00938,0.32941-7.44517c0.5043-1.17396,1.23639-2.18015,2.33115-2.88895
                                c1.43109-0.9261,3.16739-0.86619,4.53217,0.15598c1.34073,1.00399,2.08948,2.38925,2.54947,3.95566
                                c0.12805,0.43599,0.22556,0.88516,0.28894,1.33513c0.07486,0.53146,0.09744,1.0703,0.12265,1.36868
                                C295.90695,11.66406,295.53287,13.34791,294.62726,14.89035z"/>
                            <path class="st0" fill="#ffffff" d="M19.14227,3.10126c0.31558-0.16876,0.6453-0.31795,0.98203-0.43879
                                c0.45529-0.16337,0.92331-0.29139,1.45107-0.45476c-2.14497,0-4.21682,0-6.29344,0
                                c-1.51206,3.00919-3.01296,5.9962-4.51453,8.98282c-0.01403,0.02776-0.03535,0.05273-0.0562,0.07629
                                c-0.01009,0.01158-0.02614,0.01957-0.04104,0.02437c-0.0152,0.00499-0.03233,0.00379-0.11659,0.01158
                                c-1.36012-3.05492-2.7294-6.13041-4.08798-9.18174c-2.1405,0-4.22618,0-6.27444,0c0.36079,0.10425,0.76014,0.19133,1.13818,0.33453
                                C2.21695,2.79189,2.71337,3.54384,2.7134,4.4963c0.00002,3.35111-0.00287,6.70201,0.002,10.05312
                                c0.0014,0.97324-0.46188,1.6411-1.32018,2.04474C0.95679,16.80047,0.49725,16.96185,0,17.16256c1.97903,0,3.90673,0,5.86256,0
                                c-0.43701-0.18993-0.86332-0.34192-1.25726-0.55382C3.8585,16.2069,3.45584,15.59176,3.45913,14.71
                                c0.01186-3.15478,0.00414-6.30976,0.00539-9.46454C3.46457,5.12382,3.4809,5.00219,3.48964,4.88076
                                C3.51817,4.87238,3.54671,4.86399,3.57527,4.8554c1.86594,3.70681,3.73185,7.41362,5.62849,11.18134
                                c0.51498-0.98522,0.99668-1.90533,1.47698-2.82604c0.48272-0.9257,0.96445-1.85161,1.4459-2.77791
                                c0.48874-0.94008,0.96607-1.88656,1.46789-2.81965c0.48869-0.90873,0.91722-1.85181,1.45501-2.73317
                                c0.0366,0.00959,0.07322,0.01957,0.10982,0.02916c0,0.17276,0,0.34532,0,0.51807c0,3.31835-0.01233,6.6367,0.01266,9.95486
                                c0.00394,0.52626-0.16829,0.88216-0.59734,1.12822c-0.41584,0.23827-0.84711,0.44997-1.23342,0.65309c2.40263,0,4.8561,0,7.30956,0
                                c-0.55782-0.2123-1.09165-0.43639-1.58046-0.77811c-0.3561-0.24905-0.50594-0.52387-0.50382-0.97304
                                c0.01772-3.77591,0.01775-7.55202-0.00305-11.32794C18.56086,3.59936,18.75943,3.30597,19.14227,3.10126z"/>
                            <path class="st0" fill="#ffffff" d="M239.56818,15.74435c-0.83159-1.16756-1.66245-2.33593-2.49486-3.50309
                                c-0.49036-0.68744-0.98317-1.37328-1.49757-2.09147c0.12888-0.04793,0.21408-0.08868,0.3038-0.11144
                                c0.44183-0.11264,0.89502-0.19073,1.32549-0.33613c0.98862-0.33413,1.88432-0.82844,2.52805-1.68184
                                c1.03737-1.37527,0.81119-3.47194-0.298-4.76113c-0.86903-1.00999-1.99184-1.44657-3.29294-1.44937
                                c-4.18477-0.00899-8.36954-0.00359-12.55431-0.00399c-0.18491,0-0.36986,0-0.64578,0
                                c0.5472,0.20771,1.01607,0.35271,1.45465,0.56121c0.43666,0.20771,0.84296,0.47913,1.22385,0.70022
                                c0.01778,0.12323,0.03073,0.17116,0.03075,0.21929c0.0016,4.01897,0.00313,8.03794-0.00079,12.05711
                                c-0.00015,0.1416-0.02489,0.29898-0.08975,0.42181c-0.23247,0.44038-0.54129,0.81486-1.01128,1.02656
                                c-0.16016,0.0719-0.31853,0.14779-0.47774,0.22189c0.00682,0.01718,0.01369,0.03415,0.02049,0.05133c2.38858,0,4.77716,0,7.16574,0
                                c-0.0641-0.07769-0.13481-0.11384-0.20958-0.13681c-0.74246-0.22788-1.33333-0.66247-1.81476-1.27042
                                c-0.15288-0.19313-0.22701-0.37527-0.22594-0.61773c0.00679-1.51927,0.00232-3.03874,0.00513-4.55822
                                c0.0002-0.10865,0.028-0.2173,0.04483-0.33952c0.80757,0,1.58902,0,2.39363,0c1.71799,2.2826,3.43961,4.57,5.13603,6.82384
                                c2.02191,0,3.98352,0,5.94511,0c-0.7942-0.1456-1.55946-0.3573-2.29883-0.67565
                                C239.94962,16.16856,239.74059,15.98661,239.56818,15.74435z M229.48271,9.40443c-0.1118-0.0006-0.22353-0.01098-0.37708-0.01897
                                c0-2.38766,0-4.71879,0-7.07869c0.11328-0.00979,0.2068-0.02497,0.30035-0.02516c1.32431-0.0014,2.64867-0.0028,3.97301,0
                                c0.7173,0.0018,1.39203,0.17915,2.00044,0.55862c0.7843,0.48931,1.21436,1.22848,1.3436,2.12403
                                c0.112,0.77611,0.08347,1.55502-0.12907,2.32235c-0.38118,1.37607-1.47018,2.17316-2.84491,2.14679
                                C232.32727,9.40603,230.90483,9.41342,229.48271,9.40443z"/>
                            <path class="st0" fill="#ffffff" d="M60.77481,15.51088c-1.20449-1.6439-2.40211-3.29299-3.59881-4.94248
                                c-0.08099-0.11164-0.13931-0.23966-0.22386-0.38766c0.92708-0.14639,1.77214-0.37767,2.56004-0.79009
                                c0.76595-0.40084,1.4258-0.91672,1.84409-1.69463c0.89138-1.65828,0.28625-3.84122-1.19076-4.95446
                                c-0.75582-0.5696-1.61556-0.83423-2.5553-0.83603c-2.46852-0.00459-4.93706-0.0014-7.4056-0.0014c-1.92842,0-3.85682,0-5.89539,0
                                c0.85021,0.26323,1.57557,0.53685,2.22084,0.99241c0.3419,0.24126,0.52047,0.50849,0.5178,0.96745
                                c-0.0215,3.70881-0.01204,7.41781-0.01206,11.12702c0,0.09786,0.00482,0.19633-0.00165,0.29399
                                c-0.04004,0.60335-0.23337,1.10985-0.83311,1.38366c-0.29154,0.13321-0.56711,0.30138-0.92808,0.4957c2.52479,0,4.95666,0,7.3885,0
                                c-0.15591-0.11144-0.32078-0.17455-0.48624-0.23587c-0.52761-0.19593-0.98522-0.50449-1.4118-0.86559
                                c-0.26683-0.22608-0.38149-0.49511-0.37765-0.8562c0.0162-1.51927,0.00632-3.03894,0.00774-4.55842
                                c0.00012-0.12622,0.01343-0.25225,0.02187-0.40044c0.82611,0,1.6202,0,2.41157,0c1.72234,2.2876,3.43551,4.56341,5.13336,6.81865
                                c2.05462,0,4.05946,0,6.06431,0c-1.02719-0.19193-1.99416-0.51568-2.83513-1.14879
                                C61.03582,15.80187,60.88792,15.66526,60.77481,15.51088z M50.69637,9.50029c-0.06364-0.0004-0.12717-0.01598-0.18569-0.02377
                                c-0.1068-0.34911-0.13676-6.41142-0.02701-7.09826c0.37575,0,0.73342,0,1.09112,0c1.09384,0,2.18808-0.01837,3.28138,0.00539
                                c1.03817,0.02277,1.94275,0.37208,2.61549,1.20851c0.38074,0.47314,0.57514,1.02756,0.64108,1.61394
                                c0.08783,0.78111,0.05103,1.56401-0.19647,2.32035c-0.40216,1.22888-1.39824,1.98802-2.66587,1.9958
                                C53.7325,9.53165,52.2144,9.50988,50.69637,9.50029z"/>
                            <path class="st0" fill="#ffffff" d="M198.13675,9.43459c-0.12946-0.08568-0.24852-0.18694-0.36693-0.27681
                                c0.04002-0.0709,0.04929-0.10745,0.07272-0.12542c0.07732-0.05892,0.15805-0.11404,0.24043-0.16597
                                c0.67149-0.42281,1.17645-0.999,1.44296-1.74056c0.56293-1.56601,0.49005-2.88855-1.12193-4.17156
                                c-0.8954-0.7128-1.93924-0.96944-3.06288-0.96944c-3.98807,0.0004-7.97614,0.0002-11.9642,0.0002c-0.16594,0-0.33191,0-0.49788,0
                                c0.96136,0.32694,1.89984,0.64749,2.73654,1.33753c0,0.17575,0,0.3543-0.00002,0.53305c0,3.70801-0.00949,7.41621,0.01103,11.12422
                                c0.00282,0.51208-0.12511,0.93369-0.46773,1.2852c-0.20111,0.20631-0.43758,0.38826-0.68481,0.53705
                                c-0.28442,0.17096-0.59825,0.29319-0.92824,0.45037c0.0699,0.00679,0.10233,0.01258,0.13475,0.01258
                                c3.54674,0.0012,7.09355,0.01618,10.64018-0.00579c1.04666-0.00639,2.07635-0.20312,3.04953-0.61574
                                c0.82321-0.34911,1.57925-0.80687,2.07014-1.57939c0.85403-1.34372,1.00731-2.73497,0.16983-4.15218
                                C199.2468,10.29678,198.72968,9.82624,198.13675,9.43459z M196.21884,14.83922c-0.49702,1.1444-1.44667,1.76673-2.6891,1.81007
                                c-1.4359,0.05013-2.87491,0.01039-4.31256,0.00799c-0.04736,0-0.0947-0.01837-0.23108-0.04673
                                c0.02763-2.36649-0.0542-4.7114,0.07172-7.08488c0.11729-0.01837,0.22409-0.04933,0.33099-0.04973
                                c1.45404-0.00359,2.9082-0.01598,4.36201,0.001c0.98863,0.01158,1.7905,0.43938,2.25908,1.31076
                                C196.71036,12.09027,196.81131,13.47493,196.21884,14.83922z M196.65797,6.51727c-0.22226,1.21889-1.02434,1.92411-2.19801,2.22928
                                c-0.2187,0.05672-0.45015,0.08887-0.67593,0.09007c-1.47046,0.00779-2.94102,0.00419-4.41154,0.003
                                c-0.09692,0-0.1938-0.01039-0.3783-0.02097c0.01465-2.08967-0.06541-4.1382,0.06903-6.2137
                                c0.11214-0.01118,0.20531-0.02856,0.29855-0.02896c1.51942-0.00519,3.03886-0.01498,4.55821-0.00619
                                c0.32277,0.002,0.65479,0.03835,0.96574,0.12143c0.73688,0.19712,1.25352,0.66008,1.547,1.37467
                                C196.75981,4.86239,196.80832,5.69263,196.65797,6.51727z"/>
                            <path class="st0" fill="#ffffff" d="M107.13892,2.01757c0.17323,0.07929,0.26118,0.12063,0.34996,0.16018
                                c0.64058,0.2848,1.28707,0.55742,1.92036,0.8576c0.58158,0.27581,0.8577,0.7172,0.85305,1.40064
                                c-0.02339,3.43159-0.01778,6.86339-0.00279,10.29518c0.00212,0.48892-0.13923,0.88776-0.43726,1.25844
                                c-0.2513,0.31276-0.55418,0.55323-0.91489,0.71939c-0.26344,0.12143-0.5352,0.22468-0.82435,0.34472
                                c2.07013,0.10885,16.09092,0.05392,16.47453-0.06311c0.00034-1.60575,0.00034-3.2115,0.00034-4.81705
                                c-0.12041,0.23986-0.19275,0.48712-0.27239,0.73217c-0.33111,1.01917-0.75619,1.98003-1.59441,2.70481
                                c-0.67476,0.58318-1.42161,0.98182-2.33493,0.98342c-2.15833,0.0038-4.31668,0.002-6.47501-0.0006
                                c-0.12311-0.0002-0.24615-0.02696-0.35368-0.03975c0-2.3569,0-4.66966,0-6.98162c0.07994-0.01498,0.12675-0.03136,0.17358-0.03156
                                c1.27536-0.0022,2.551-0.01618,3.82592,0.00779c0.26273,0.00499,0.55097,0.10525,0.77873,0.24246
                                c0.62857,0.37847,1.11142,0.90314,1.38976,1.59577c0.10772,0.26803,0.2149,0.53645,0.34227,0.8544c0-1.9241,0-3.79089,0-5.76173
                                c-0.18222,0.31037-0.29761,0.54204-0.44533,0.75075c-0.27235,0.38506-0.5561,0.76253-0.84921,1.13181
                                c-0.3075,0.38746-0.72126,0.51767-1.2128,0.51108c-1.20973-0.01658-2.41986-0.00439-3.62984-0.00679
                                c-0.12437-0.0002-0.24873-0.02017-0.37822-0.03136c0-2.11763,0-4.20092,0-6.31116c0.15316-0.01198,0.27971-0.03036,0.40626-0.03056
                                c2.24009-0.0016,4.48018-0.0018,6.72029,0.001c0.14545,0.0002,0.29279,0.01638,0.43599,0.04294
                                c1.11341,0.20591,1.93653,0.84122,2.51907,1.7819c0.3074,0.4965,0.53938,1.03974,0.8044,1.56221
                                c0.0739,0.1458,0.1442,0.29319,0.21618,0.43998c0.05954-1.44937,0.09207-2.87817,0.0507-4.30337
                                C118.82111,2.01757,113.02386,2.01757,107.13892,2.01757z"/>
                            <path class="st0" fill="#ffffff" d="M139.82468,7.97423c-0.99374-0.05053-1.98949-0.0701-2.98462-0.08308
                                c-0.91518-0.01198-1.82648-0.05492-2.72806-0.22009c-0.61235-0.11224-1.21283-0.27022-1.75452-0.58878
                                c-0.57558-0.33813-0.98882-0.81546-1.06816-1.4969c-0.1174-1.00879,0.16769-1.88516,1.01012-2.5027
                                c0.31044-0.22748,0.67136-0.41362,1.03717-0.53365c1.58623-0.52067,3.22221-0.76153,4.86958-0.44158
                                c1.81303,0.35231,3.3378,1.2123,4.23952,2.92071c0.30234,0.5728,0.56825,1.16477,0.86273,1.77272c0-1.91352,0-3.80487,0-5.75554
                                c-0.18521,0.39904-0.3157,0.75195-0.50447,1.0705c-0.3026,0.51049-0.63043,0.65229-1.19395,0.50689
                                c-0.45503-0.11744-0.89668-0.289-1.34012-0.44817c-0.3367-0.12083-0.65683-0.30278-1.00166-0.38326
                                c-1.46844-0.34332-2.95485-0.47074-4.46248-0.31915c-1.21103,0.12163-2.32817,0.4963-3.32111,1.20092
                                c-1.02316,0.72578-1.72276,1.67286-1.93199,2.94168c-0.1104,0.66946-0.1068,1.33393,0.04634,1.99341
                                c0.36368,1.56621,1.23564,2.68204,2.84961,3.08208c1.04848,0.26004,2.12415,0.32375,3.20341,0.32195
                                c1.45279-0.0028,2.90326,0.02596,4.35197,0.16896c1.21567,0.11983,2.00739,0.78889,2.53667,1.82624
                                c0.11519,0.22568,0.18221,0.49371,0.20145,0.74755c0.08269,1.09107-0.4807,1.82664-1.3775,2.34352
                                c-0.26508,0.15259-0.56729,0.24606-0.85963,0.34572c-2.02092,0.68904-4.07323,0.87118-6.16107,0.34392
                                c-0.90773-0.22908-1.75958-0.58917-2.53076-1.13241c-0.87073-0.61374-1.41762-1.47154-1.85361-2.41382
                                c-0.25192-0.54424-0.48299-1.09826-0.75926-1.72978c0,2.11803,0,4.15039,0,6.26602c0.09615-0.15678,0.1452-0.25384,0.20987-0.33912
                                c0.16696-0.22029,0.32497-0.45037,0.5152-0.64929c0.39595-0.41382,0.87952-0.54204,1.4269-0.35011
                                c0.36902,0.12942,0.73483,0.26982,1.09528,0.42141c1.33972,0.56341,2.7419,0.8532,4.18768,0.88416
                                c0.6644,0.01418,1.33176-0.09587,1.99738-0.15418c1.40405-0.12303,2.6517-0.65908,3.78165-1.47513
                                c0.73308-0.52926,1.27-1.2159,1.50583-2.10845c0.18558-0.70262,0.19809-1.40264,0.11136-2.13022
                                C143.74583,9.48212,141.58101,8.06351,139.82468,7.97423z"/>
                            <path class="st0" fill="#ffffff" d="M41.02362,15.47293c-0.83001-1.77152-1.6792-3.53425-2.51942-5.30118
                                c-1.54763-3.25424-3.09397-6.50928-4.64272-9.76313c-0.04416-0.09287-0.10972-0.17535-0.18936-0.30058
                                c-0.88428,1.82325-1.74498,3.59576-2.60378,5.36928c-1.52786,3.15518-3.06446,6.30617-4.5726,9.47074
                                c-0.26748,0.56121-0.63571,0.97563-1.17466,1.25764c-0.13009,0.06791-0.25509,0.14699-0.3889,0.20651
                                c-0.56623,0.25165-1.13489,0.4975-1.72404,0.75494c2.07392,0,4.1238,0,6.28962,0c-0.25547-0.10665-0.40368-0.16876-0.55213-0.23048
                                c-0.42174-0.17535-0.84971-0.33713-1.26393-0.52866c-0.59669-0.27581-0.73013-0.66627-0.46445-1.28181
                                c0.0193-0.04474,0.04576-0.08628,0.06646-0.13042c0.51166-1.09087,1.02207-2.18254,1.53475-3.27302
                                c0.22818-0.48532,0.46083-0.96864,0.68933-1.44837c1.86911,0,3.70908,0,5.55759,0c0.30894,0.65888,0.60752,1.29259,0.90356,1.9275
                                c0.51683,1.10845,1.03425,2.2167,1.54701,3.32694c0.1971,0.4268,0.1445,0.61674-0.26817,0.84422
                                c-0.31336,0.17276-0.6445,0.31616-0.97601,0.45237c-0.28552,0.11724-0.58278,0.20591-0.87482,0.30737
                                c0.0038,0.01398,0.00759,0.02816,0.01139,0.04214c2.63039,0,5.26075,0,7.99622,0c-0.40194-0.16457-0.69927-0.26003-0.97129-0.40323
                                C41.85168,16.46514,41.32038,16.10624,41.02362,15.47293z M29.86814,9.54703c0.82524-1.75334,1.61284-3.4268,2.40868-5.11763
                                c0.26563,0.30078,2.22898,4.30078,2.51036,5.10126C33.1633,9.56281,31.55833,9.53824,29.86814,9.54703z"/>
                            <path class="st0" fill="#ffffff" d="M219.31914,15.19891c-0.11157-0.33773-0.29411-0.65249-0.44827-0.97603
                                c-1.73964-3.65089-3.4794-7.30177-5.22034-10.95206c-0.51877-1.08788-1.04121-2.17376-1.5668-3.27082
                                c-0.03146,0.04094-0.05388,0.06171-0.06621,0.08748c-1.02617,2.12982-2.05208,4.26003-3.07684,6.39065
                                c-1.3564,2.82005-2.71449,5.6395-4.06326,8.46335c-0.11673,0.24426-0.26999,0.44058-0.47772,0.60375
                                c-0.69603,0.54643-1.42303,1.03815-2.28085,1.30277c-0.1687,0.05193-0.33234,0.12043-0.49834,0.18115
                                c0.00262,0.01398,0.00525,0.02796,0.00787,0.04194c1.95456,0,3.90915,0,5.86371,0c-0.05267-0.05293-0.1106-0.05951-0.1669-0.0729
                                c-0.55609-0.13222-1.11237-0.26503-1.58603-0.61015c-0.4778-0.34791-0.54863-0.60096-0.30067-1.11883
                                c0.63387-1.32375,1.27214-2.6455,1.90858-3.96824c0.17473-0.36309,0.34927-0.72618,0.52029-1.08189c1.87411,0,3.70418,0,5.59668,0
                                c0.87189,1.88716,1.73674,3.75914,2.59363,5.61394c-0.71117,0.60016-1.50909,0.89015-2.39775,1.23667
                                c2.73932,0,5.36241,0,8.07062,0c-0.46916-0.22708-0.86845-0.40244-1.2506-0.60954
                                C219.95288,16.17475,219.51871,15.80347,219.31914,15.19891z M208.26241,9.4242c0.80806-1.717,1.59578-3.39045,2.38353-5.06411
                                c0.03882-0.0014,0.07762-0.0028,0.11641-0.00419c0.8085,1.67745,1.61696,3.3551,2.44261,5.0683
                                C211.53683,9.4242,209.92824,9.4242,208.26241,9.4242z"/>
                            <path class="st0" fill="#ffffff" d="M79.77844,15.73197c-1.50471,1.30757-3.25781,1.83024-5.21889,1.52407
                                c-1.4071-0.21989-2.48642-1.01957-3.31633-2.16117c-1.18691-1.63291-1.62837-3.50549-1.68664-5.47753
                                c-0.02247-0.76033,0.06518-1.53185,0.17954-2.2866c0.19466-1.2846,0.60341-2.5003,1.35922-3.57979
                                c0.70269-1.00359,1.61369-1.71899,2.83968-1.91851c0.55799-0.09087,1.14115-0.06191,1.71095-0.03895
                                c1.48624,0.06012,2.7448,0.66627,3.79761,1.69463c0.68881,0.67286,1.11095,1.52606,1.4845,2.39884
                                c0.22685,0.52986,0.42041,1.0741,0.6588,1.68903c0-2.15159,0-4.21789,0-6.2844c-0.02119-0.00679-0.04237-0.01338-0.06356-0.02017
                                c-0.20374,0.38626-0.40266,0.77511-0.61254,1.15798c-0.24139,0.44058-0.48974,0.5692-0.96523,0.42241
                                c-0.30422-0.09387-0.59247-0.25864-0.86721-0.4256c-1.75953-1.0697-3.6599-1.42221-5.68831-1.13821
                                c-2.42343,0.33932-4.37028,1.50709-5.78158,3.48672c-1.45663,2.04314-1.94744,4.32454-1.31329,6.7801
                                c0.52762,2.04314,1.7526,3.61873,3.45052,4.84242c1.27124,0.91632,2.69542,1.46275,4.24396,1.6435
                                c1.06064,0.12363,2.1203,0.01797,3.15462-0.26683c2.5167-0.69303,4.31918-2.2149,5.35101-4.62412
                                c0.04652-0.10845,0.05804-0.23207,0.0893-0.36289c-0.23944,0-0.42787,0-0.61289,0
                                C81.42454,13.92809,80.71608,14.91711,79.77844,15.73197z"/>
                            <path class="st0" fill="#ffffff" d="M275.42291,16.6399c-0.21835,0.09287-0.47156,0.1432-0.70926,0.1452
                                c-1.4718,0.01298-2.94373,0.00719-4.41562,0.00539c-0.1098-0.0002-0.21957-0.01698-0.35352-0.02796
                                c-0.00946-0.17136-0.02426-0.31436-0.02429-0.45736c-0.00128-3.98821,0.00168-7.97643-0.00589-11.96464
                                c-0.00064-0.32834,0.0907-0.60296,0.27075-0.86838c0.2179-0.32135,0.50592-0.55342,0.84979-0.71879
                                c0.24734-0.11883,0.50333-0.21989,0.79877-0.34771c-2.6312,0-5.2157,0-7.85651,0c0.34219,0.12742,0.63959,0.2153,0.91681,0.34612
                                c0.46924,0.22129,0.93158,0.45896,1.38562,0.71021c0.36096,0.19952,0.48788,0.51448,0.48639,0.93829
                                c-0.01303,3.66127-0.01294,7.32254-0.00009,10.98382c0.00171,0.49131-0.18463,0.8542-0.55511,1.13501
                                c-0.20642,0.15638-0.43478,0.2888-0.66656,0.40563c-0.36166,0.18254-0.73459,0.34252-1.15561,0.53645
                                c4.82318,0,9.59164,0,14.41745,0c0-1.84761,0-3.65388,0-5.40064c-0.168,0.52227-0.35101,1.09447-0.53613,1.66607
                                C277.80307,15.16776,276.7728,16.0649,275.42291,16.6399z"/>
                            <path class="st0" fill="#ffffff" d="M153.33,15.47413c0.01988-0.7841,0.0056-1.5688,0.0056-2.3533
                                c-0.00003-3.05652-0.0014-6.11284,0.00099-9.16916c0.00063-0.81007,0.39717-1.37208,1.15436-1.62932
                                c0.25867-0.08788,0.53017-0.13821,0.78218-0.20212c-2.39507,0-4.80975,0-7.22443,0
                                c0.06383,0.04194,0.12909,0.03315,0.19128,0.04314c1.01408,0.16477,1.76675,0.65928,1.75983,1.94867
                                c-0.02011,3.75894-0.01413,7.51827,0.00125,11.27721c0.00204,0.5005-0.16968,0.84781-0.58907,1.09207
                                c-0.23947,0.1394-0.46919,0.29978-0.71989,0.41482c-0.23174,0.10605-0.48555,0.16417-0.78992,0.26283
                                c2.53369,0,4.99844,0,7.46317,0c-0.57556-0.13341-1.0719-0.40144-1.54189-0.73816
                                C153.4922,16.18353,153.31931,15.89634,153.33,15.47413z"/>
                            <path class="st0" fill="#ffffff" d="M171.01564,11.27141c-0.65294-1.26982-1.68069-2.04853-3.12617-2.09527
                                c-1.6776-0.05412-3.35832-0.01258-5.09674-0.01258c0.48697,0.22908,0.9866,0.31156,1.31216,0.67725
                                c0.00945,0.05912,0.01898,0.09127,0.019,0.12343c0.00163,2.00799-0.00346,4.01618,0.00862,6.02436
                                c0.00227,0.37547-0.18727,0.61134-0.45491,0.81406c-0.11235,0.08508-0.24657,0.1412-0.37083,0.2107
                                c0.00476,0.02497,0.00954,0.04993,0.01428,0.07509c0.1548,0,0.30962,0,0.46442,0c1.07814,0.0002,2.15636-0.00759,3.23441,0.0032
                                c0.74597,0.00739,1.45705-0.141,2.14317-0.42121c1.38286-0.56501,2.11656-1.58598,2.12227-3.08947
                                c0.00203-0.53605-0.04349-1.0739-0.09387-1.60855C171.16901,11.73437,171.12329,11.48072,171.01564,11.27141z M169.32219,14.92709
                                c-0.15401,0.35311-0.36667,0.69483-0.61476,0.98941c-0.38068,0.45177-0.8609,0.73238-1.498,0.67865
                                c-0.41768-0.03535-0.84073-0.00659-1.28723-0.00659c0-2.39864,0-4.74176,0-7.12982c0.81506,0.01538,1.61-0.1444,2.34419,0.33613
                                c0.90817,0.59437,1.33426,1.46016,1.43452,2.49491C169.78831,13.19192,169.68794,14.08847,169.32219,14.92709z"/>
                            <path class="st0" fill="#ffffff" d="M177.19936,9.16636c-1.08559,0-2.2135,0-3.41949,0c0.73071,0.25125,0.86533,0.43878,0.86542,1.15538
                                c0.00018,1.81406-0.02928,3.62912,0.01613,5.44218c0.01468,0.58658-0.18791,0.92171-0.69188,1.13521
                                c-0.01781,0.00739-0.0224,0.04634-0.03748,0.08009c1.08179,0,2.15903,0,3.23602,0
                                c-0.26326-0.19033-0.52013-0.37587-0.77412-0.55962c0-0.20671,0-0.36928,0-0.53165c0-1.84701,0.00035-3.69383-0.00047-5.54064
                                c-0.00009-0.27781-0.03918-0.57619,0.1987-0.77791C176.78401,9.40663,177.01297,9.28779,177.19936,9.16636z"/>
                            <path class="st0" fill="#ffffff" d="M103.24787,3.03595c0.57974-0.26922,1.1476-0.56421,1.69151-0.83343c-2.57561,0-5.1909,0-7.81812,0
                                c0.52731,0.26782,1.01897,0.52067,1.51328,0.76812c0.4065,0.20352,0.56945,0.5025,0.56703,0.98023
                                c-0.00909,1.78949-0.01385,3.57919-0.01434,5.36868c-2.59064,0.0022-5.46749,0.0026-8.0508,0.0018
                                c-0.06438,0-0.129-0.01518-0.19293-0.02616c-0.0139-0.0024-0.02616-0.01738-0.03792-0.02796
                                c-0.01213-0.01099-0.02277-0.02337-0.06756-0.0703c0-0.12682,0-0.28899,0-0.45117c0.00008-1.55223,0.01601-3.10485-0.00881-4.65668
                                c-0.00809-0.50529,0.15366-0.83942,0.61374-1.05313c0.57974-0.26922,1.1476-0.56421,1.69151-0.83343c-2.57561,0-5.1909,0-7.81812,0
                                c0.52731,0.26782,1.01897,0.52067,1.51328,0.76812c0.4065,0.20352,0.56945,0.5025,0.56703,0.98023
                                c-0.01907,3.75794-0.02219,7.51627,0.00332,11.27421c0.00347,0.51268-0.15426,0.84022-0.58304,1.0687
                                c-0.4949,0.26343-0.99059,0.52567-1.47655,0.7833c2.47062,0,4.95876,0,7.44687,0c-0.51715-0.18854-0.98387-0.44098-1.43372-0.74236
                                c-0.31865-0.2135-0.45991-0.46555-0.45711-0.85061c0.01248-1.7156,0.00469-3.43139,0.00704-5.14699
                                c0.00018-0.12403,0.02287-0.24805,0.03435-0.36449c0.77519-0.08608,7.3218-0.06072,8.25005,0.02816
                                c0.0008,1.74136,0.0052,3.48292,0.01703,5.22428c0.00347,0.51268-0.15426,0.84022-0.58303,1.0687
                                c-0.49491,0.26343-0.99059,0.52567-1.47656,0.7833c2.47062,0,4.95876,0,7.44687,0
                                c-0.51717-0.18854-0.98387-0.44098-1.43372-0.74236c-0.31865-0.2135-0.4599-0.46555-0.45711-0.85061
                                c0.01248-1.7156-0.05842-6.57619-0.0584-6.73836c0.00008-1.55223,0.01601-3.10485-0.00881-4.65668
                                C102.62605,3.58378,102.7878,3.24965,103.24787,3.03595z"/>
                            <path class="st0" fill="#ffffff" d="M257.8248,3.13721c-2.0061-1.41003-4.26112-1.8534-6.66238-1.42181
                                c-2.17113,0.39025-3.96661,1.46555-5.31085,3.22548c-1.24409,1.62872-1.804,3.46834-1.62939,5.53225
                                c0.16841,1.99121,0.98219,3.68863,2.39421,5.05173c1.89847,1.83283,4.20322,2.66527,6.86302,2.46615
                                c1.39326-0.10425,2.68945-0.5025,3.87384-1.23008c2.04373-1.25524,3.37482-3.03415,3.86905-5.40423
                                c0.06506-0.31216,0.12827-0.62473,0.19232-0.93709c0-0.425,0-0.85001,0-1.27501c-0.0289-0.0715-0.07578-0.1412-0.0842-0.2151
                                C261.04965,6.46155,259.82874,4.54563,257.8248,3.13721z M256.88177,14.89035c-0.48547,0.82664-1.10599,1.53585-1.93132,2.04394
                                c-1.54115,0.94867-3.28514,0.82345-4.68066-0.33213c-1.1019-0.91232-1.80869-2.08528-2.23787-3.43419
                                c-0.80194-2.52087-0.71684-5.00938,0.32944-7.44517c0.50427-1.17396,1.23634-2.18015,2.33112-2.88895
                                c1.43109-0.9261,3.16742-0.86619,4.53215,0.15598c1.34074,1.00399,2.08949,2.38925,2.54948,3.95566
                                c0.12808,0.43599,0.22559,0.88516,0.28894,1.33513c0.07486,0.53146,0.09744,1.0703,0.12268,1.36868
                                C258.16147,11.66406,257.78741,13.34791,256.88177,14.89035z"/>
                        </g>
                    </svg>

                    <hr class="mb-5" />

                    <div class="mx-auto ms-xl-0">
                        <h2 class="h1-like-text align-control mb-4" v-html="$root.translateStringRecycling('title_1', lang)"></h2>
                        <p class="align-control mx-auto h5 px-0" v-html="$root.translateStringRecycling('text', lang)"></p>
                    </div>

                </div>
                <div class="col-24 pt-md-3 mt-4">

                    <!-- <div v-if="product.images && product.images.length > 0" class="w-100 text-center text-xl-start">
                        <img alt="vino" class="mb-4 mx-auto ms-xl-0 bottle" :src="product.images[0]" width="900" height="200" />
                    </div> -->

                    <div class="shop-single-item__content p-0 recycle w-100 align-control pt-3">
                        <h3 :class="['h2 text-center text-primary', combinationName ? 'mb-2' : 'mb-4']">
                            {{ productName }}
                        </h3>
                        <h4 v-if="combinationName" class="h4 text-center mb-4 text-primary" v-html="combinationName">
                        </h4>
                    </div>

                    <p class="align-control mx-auto h4 font-italic px-0 pt-5 pb-2 mb-4" style="opacity:.5" v-html="$root.translateStringRecycling('table-title-1', lang)"></p>

                    <template v-for="(element, index) in recycle">

                        <div v-if="element != null && typeof trashDestination[index] != 'undefined' && typeof trashDestination[index]['materials'][element] != 'undefined'" class="table-mobile d-flex flex-column w-100 mx-auto mb-5 d-xl-none px-2">

                            <div class="title-block p-3 bg-lightgold text-center bg-black mb-4">
                                <span class="h8 text-primary text-uppercase d-block fw-normal p-0 m-0">
                                    <span class="text-black">{{ trashDestination[index].label[lang] }}</span>
                                </span>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="h8 simple-text text-secondary text-uppercase text-gold">{{ $root.translateStringRecycling('tipo', lang) }}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="h8 text-end">{{ trashDestination[index]['materials'][element].label[lang] }}</span>
                                </div>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="h8 simple-text text-secondary text-uppercase text-gold">{{ $root.translateStringRecycling('simbolo', lang) }}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="h8 text-end">
                                        <img alt="simbolo" class="my-2" :src="'/images/recycle/' + trashDestination[index]['materials'][element].symbol + '.svg'" :width="trashDestination[index]['materials'][element].symbol == 'misti' ? 90 : 45" height="45" />
                                    </span>
                                </div>
                            </div>

                            <div class="block d-flex">
                                <div class="flex-grow-1 d-flex align-items-center label-td">
                                    <span class="h8 simple-text text-secondary text-uppercase text-gold">{{ $root.translateStringRecycling('destinazione', lang) }}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center content-td">
                                    <span class="h8 text-end">{{ trashDestination[index]['materials'][element].destination[lang] }}</span>
                                </div>
                            </div>

                        </div>

                    </template>

                    <!-- DESKTOP -->

                    <table class="table ml-0 d-none d-xl-table" style="max-width: 1000px">
                        <thead>
                            <tr class=" border-bottom border-white--opaque">
                                <th scope="col" class="text-center py-3 px-4 border-0 bg-gold">
                                    <span class="h8 text-primary d-block fw-normal p-0 m-0">
                                        <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('macrocategoria', lang) }}</span>
                                    </span>
                                </th>
                                <th scope="col" class="text-center py-3 px-4 border-0 bg-gold">
                                    <span class="h8 text-primary d-block fw-normal p-0 m-0">
                                        <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('tipo', lang) }}</span>
                                    </span>
                                </th>
                                <th scope="col" class="text-center py-3 px-4 border-0 bg-gold">
                                    <span class="h8 text-primary d-block fw-normal p-0 m-0">
                                        <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('simbolo', lang) }}</span>
                                    </span>
                                </th>
                                <th scope="col" class="text-center py-3 px-4 border-0 bg-gold">
                                    <span class="h8 text-primary d-block fw-normal p-0 m-0">
                                        <span class="text-white text-uppercase font-weight-light">{{ $root.translateStringRecycling('destinazione', lang) }}</span>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(element, index) in recycle">
                                <tr v-if="element != null && typeof trashDestination[index] != 'undefined' && typeof trashDestination[index]['materials'][element] != 'undefined'">
                                    <td class="text-center">
                                        <span class="text-primary d-block fw-normal">
                                            <span class="text-black">
                                                {{ trashDestination[index].label[lang] }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span class="text-secondary">
                                            {{ trashDestination[index]['materials'][element].label[lang] }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <img alt="simbolo" class="my-2" :src="'/images/recycle/' + trashDestination[index]['materials'][element].symbol + '.svg'" :width="trashDestination[index]['materials'][element].symbol == 'misti' ? 90 : 45" height="45" />
                                    </td>
                                    <td class="text-center">
                                        <span class="text-secondary">{{ trashDestination[index]['materials'][element].destination[lang] }}</span>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>

                    <!-- <div class="text-center text-xl-start mt-5 pt-3">
                        <a :href="lang == 'it' ? 'https://marchesibarolo.com/it/vini' : 'https://marchesibarolo.com/en/wines'" target="_blank" class="btn d-inline-flex btn-primary pt-25 pb-35 ps-5 pe-55 h-auto h7">
                            <span class="d-block text-uppercase px-4">
                                <span v-if="lang == 'it'">Vedi tutti i nostri vini</span>
                                <span v-else>See all our wines</span>
                            </span>
                        </a>
                    </div> -->
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: ['lang', 'product', 'combinationId'],
        data() {
            return {
                languageSelectorOpened: false,
                additionalLanguages: [
                    {
                        id: 'bg',
                        label: 'Български',
                    },
                    {
                        id: 'cs',
                        label: 'Čeština',
                    },
                    {
                        id: 'hr',
                        label: 'Hrvatski',
                    },
                    {
                        id: 'da',
                        label: 'Dansk',
                    },
                    {
                        id: 'et',
                        label: 'Eesti',
                    },
                    {
                        id: 'fi',
                        label: 'Suomi',
                    },
                    {
                        id: 'el',
                        label: 'Ελληνικά',
                    },
                    {
                        id: 'ga',
                        label: 'Gaeilge',
                    },
                    {
                        id: 'lv',
                        label: 'Latviešu',
                    },
                    {
                        id: 'lt',
                        label: 'Lietuvių',
                    },
                    {
                        id: 'mt',
                        label: 'Malti',
                    },
                    {
                        id: 'nl',
                        label: 'Nederlands',
                    },
                    {
                        id: 'pl',
                        label: 'Polski',
                    },
                    {
                        id: 'pt',
                        label: 'Português',
                    },
                    {
                        id: 'ro',
                        label: 'Română',
                    },
                    {
                        id: 'sk',
                        label: 'Slovenčina',
                    },
                    {
                        id: 'sl',
                        label: 'Slovenščina',
                    },
                    {
                        id: 'es',
                        label: 'Español',
                    },
                    {
                        id: 'sv',
                        label: 'Svenska',
                    },
                    {
                        id: 'hu',
                        label: 'Magyar',
                    },
                ],
                trashDestination: {
                    bottiglia: {
                        label: {
                            it: 'Bottiglia',
                            en: 'Bottle',
                            de: 'Flasche',
                            fr: 'Bouteille',
                            bg: 'Бутилка', // Bulgaro
                            cs: 'Láhev', // Ceco
                            hr: 'Boca', // Croato
                            da: 'Flaske', // Danese
                            et: 'Pudel', // Estone
                            fi: 'Pullo', // Finlandese
                            el: 'Μπουκάλι', // Greco
                            ga: 'Botail', // Irlandese
                            lv: 'Pudele', // Lettone
                            lt: 'Butelis', // Lituano
                            mt: 'Botta', // Maltese
                            nl: 'Fles', // Neerlandese
                            pl: 'Butelka', // Polacco
                            pt: 'Garrafa', // Portoghese
                            ro: 'Sticlă', // Rumeno
                            sk: 'Fľaša', // Slovacco
                            sl: 'Steklenica', // Sloveno
                            es: 'Botella', // Spagnolo
                            sv: 'Flaska', // Svedese
                            hu: 'Pohár', // Ungherese
                        },
                        materials: {
                            'incolore': {
                                label: {
                                    it: 'Vetro incolore',
                                    en: 'Colorless glass',
                                    de: 'Farbloses Glas',
                                    fr: 'Verre incolore',
                                    bg: 'Безцветно стъкло', // Bulgaro
                                    cs: 'Bezcílové sklo', // Ceco
                                    hr: 'Bezgubeno staklo', // Croato
                                    da: 'Farveløst glas', // Danese
                                    et: 'Värvitu klaas', // Estone
                                    fi: 'Värityksetön lasi', // Finlandese
                                    el: 'Αδιάφανης υαλώδης', // Greco
                                    ga: 'Gloas dorcha', // Irlandese
                                    lv: 'Krāsains stikls', // Lettone
                                    lt: 'Be spalvų stiklas', // Lituano
                                    mt: 'Ħjarab inkluż', // Maltese
                                    nl: 'Kleurloos glas', // Neerlandese
                                    pl: 'Bezczynne szkło', // Polacco
                                    pt: 'Vidro incoloro', // Portoghese
                                    ro: 'Sticlă incoloră', // Rumeno
                                    sk: 'Bezcílové sklo', // Slovacco
                                    sl: 'Brezbarvno steklo', // Sloveno
                                    es: 'Vidrio incoloro', // Spagnolo
                                    sv: 'Färgkristallt glas', // Svedese
                                    hu: 'Színtelen üveg', // Ungherese
                                },
                                symbol: 'gl-70',
                                destination: {
                                    it: 'Raccolta vetro',
                                    en: 'Glass collection',
                                    de: 'Glassammlung',
                                    fr: 'Collecte de verre',
                                    bg: 'Събиране на стъкло', // Bulgaro
                                    cs: 'Sběr skla', // Ceco
                                    hr: 'Sakupljanje stakla', // Croato
                                    da: 'Glasindsamling', // Danese
                                    et: 'Klaasi kogumine', // Estone
                                    fi: 'Lasin keräys', // Finlandese
                                    el: 'Συλλογή γυαλιού', // Greco
                                    ga: 'Bailiú gloine', // Irlandese
                                    lv: 'Stikla vākšana', // Lettone
                                    lt: 'Stiklų surinkimas', // Lituano
                                    mt: 'Ħażna ta’ ġesgħa', // Maltese
                                    nl: 'Glas inzameling', // Neerlandese
                                    pl: 'Zbieranie szkła', // Polacco
                                    pt: 'Coleta de vidro', // Portoghese
                                    ro: 'Colectare de sticlă', // Rumeno
                                    sk: 'Zber skla', // Slovacco
                                    sl: 'Zbiranje stekla', // Sloveno
                                    es: 'Recogida de vidrio', // Spagnolo
                                    sv: 'Glasinsamling', // Svedese
                                    hu: 'Üveggyűjtés', // Ungherese
                                },
                            },
                            'verde-blu': {
                                label: {
                                    it: 'Vetro verde e blu',
                                    en: 'Green and blue glass',
                                    de: 'Grünes und blaues Glas',
                                    fr: 'Verre vert et bleu',
                                    bg: 'Зелено и синьо стъкло', // Bulgaro
                                    cs: 'Zelené a modré sklo', // Ceco
                                    hr: 'Zeleno i plavo staklo', // Croato
                                    da: 'Grønt og blåt glas', // Danese
                                    et: 'Roheline ja sinine klaas', // Estone
                                    fi: 'Vihreä ja sininen lasi', // Finlandese
                                    el: 'Πράσινο και μπλε υαλώδες', // Greco
                                    ga: 'Gloas glas agus gorm', // Irlandese
                                    lv: 'Zaļš un zils stikls', // Lettone
                                    lt: 'Žalias ir mėlynas stiklas', // Lituano
                                    mt: 'Ħjarab aħmar u blu', // Maltese
                                    nl: 'Groen en blauw glas', // Neerlandese
                                    pl: 'Zielone i niebieskie szkło', // Polacco
                                    pt: 'Vidro verde e azul', // Portoghese
                                    ro: 'Sticlă verde și albastră', // Rumeno
                                    sk: 'Zelené a modré sklo', // Slovacco
                                    sl: 'Zeleno in modro steklo', // Sloveno
                                    es: 'Vidrio verde y azul', // Spagnolo
                                    sv: 'Grönt och blått glas', // Svedese
                                    hu: 'Zöld és kék üveg', // Ungherese
                                },
                                symbol: 'gl-71',
                                destination: {
                                    it: 'Raccolta vetro',
                                    en: 'Glass collection',
                                    de: 'Glassammlung',
                                    fr: 'Collecte de verre',
                                    bg: 'Събиране на стъкло',
                                    cs: 'Sběr skla',
                                    hr: 'Sakupljanje stakla',
                                    da: 'Glasindsamling',
                                    et: 'Klaasi kogumine',
                                    fi: 'Lasin keräys',
                                    el: 'Συλλογή γυαλιού',
                                    ga: 'Bailiú gloine',
                                    lv: 'Stikla vākšana',
                                    lt: 'Stiklų surinkimas',
                                    mt: 'Ħażna ta’ ġesgħa',
                                    nl: 'Glas inzameling',
                                    pl: 'Zbieranie szkła',
                                    pt: 'Coleta de vidro',
                                    ro: 'Colectare de sticlă',
                                    sk: 'Zber skla',
                                    sl: 'Zbiranje stekla',
                                    es: 'Recogida de vidrio',
                                    sv: 'Glasinsamling',
                                    hu: 'Üveggyűjtés',
                                },
                            },
                            'marrone': {
                                label: {
                                    it: 'Vetro marrone',
                                    en: 'Brown glass',
                                    de: 'Braunes Glas',
                                    fr: 'Verre marron',
                                    bg: 'Кафяво стъкло', // Bulgaro
                                    cs: 'Hnědé sklo', // Ceco
                                    hr: 'Smeđe staklo', // Croato
                                    da: 'Brunt glas', // Danese
                                    et: 'Pruun klaas', // Estone
                                    fi: 'Ruskea lasi', // Finlandese
                                    el: 'Καφέ υαλώδες', // Greco
                                    ga: 'Gloas donn', // Irlandese
                                    lv: 'Brūns stikls', // Lettone
                                    lt: 'Rudas stiklas', // Lituano
                                    mt: 'Ħjarab maron', // Maltese
                                    nl: 'Bruin glas', // Neerlandese
                                    pl: 'Brązowe szkło', // Polacco
                                    pt: 'Vidro marrom', // Portoghese
                                    ro: 'Sticlă maro', // Rumeno
                                    sk: 'Hnedé sklo', // Slovacco
                                    sl: 'Rjavo steklo', // Sloveno
                                    es: 'Vidrio marrón', // Spagnolo
                                    sv: 'Brunt glas', // Svedese
                                    hu: 'Barna üveg', // Ungherese
                                },
                                symbol: 'gl-72',
                                destination: {
                                    it: 'Raccolta vetro',
                                    en: 'Glass collection',
                                    de: 'Glassammlung',
                                    fr: 'Collecte de verre',
                                    bg: 'Събиране на стъкло',
                                    cs: 'Sběr skla',
                                    hr: 'Sakupljanje stakla',
                                    da: 'Glasindsamling',
                                    et: 'Klaasi kogumine',
                                    fi: 'Lasin keräys',
                                    el: 'Συλλογή γυαλιού',
                                    ga: 'Bailiú gloine',
                                    lv: 'Stikla vākšana',
                                    lt: 'Stiklų surinkimas',
                                    mt: 'Ħażna ta’ ġesgħa',
                                    nl: 'Glas inzameling',
                                    pl: 'Zbieranie szkła',
                                    pt: 'Coleta de vidro',
                                    ro: 'Colectare de sticlă',
                                    sk: 'Zber skla',
                                    sl: 'Zbiranje stekla',
                                    es: 'Recogida de vidrio',
                                    sv: 'Glasinsamling',
                                    hu: 'Üveggyűjtés',
                                },
                            },
                        },
                    },
                    tappo: {
                        label: {
                            it: 'Tappo',
                            en: 'Cork',
                            de: 'Kork',
                            fr: 'Bouchon',
                            bg: 'Коркова', // Bulgaro
                            cs: 'Kork', // Ceco
                            hr: 'Pluta', // Croato
                            da: 'Prop', // Danese
                            et: 'Kork', // Estone
                            fi: 'Sulkija', // Finlandese
                            el: 'Σφραγίδα', // Greco
                            ga: 'Cuircead', // Irlandese
                            lv: 'Koroka', // Lettone
                            lt: 'Korkas', // Lituano
                            mt: 'Kork', // Maltese
                            nl: 'Kurk', // Neerlandese
                            pl: 'Korek', // Polacco
                            pt: 'Tampa de cortiça', // Portoghese
                            ro: 'Tampă de plută', // Rumeno
                            sk: 'Korek', // Slovacco
                            sl: 'Tepih', // Sloveno
                            es: 'Corcho', // Spagnolo
                            sv: 'Kork', // Svedese
                            hu: 'Tömörzáró', // Ungherese
                        },
                        materials: {
                            sughero: {
                                label: {
                                    it: 'Sughero',
                                    en: 'Cork',
                                    de: 'Kork',
                                    fr: 'Liège',
                                    bg: 'Плута', // Bulgaro
                                    cs: 'Pluta', // Ceco
                                    hr: 'Pluta', // Croato
                                    da: 'Kork', // Danese
                                    et: 'Kork', // Estone
                                    fi: 'Sulkija', // Finlandese
                                    el: 'Κορκός', // Greco
                                    ga: 'Cuircead', // Irlandese
                                    lv: 'Koroka', // Lettone
                                    lt: 'Korkas', // Lituano
                                    mt: 'Kork', // Maltese
                                    nl: 'Kurk', // Neerlandese
                                    pl: 'Korek', // Polacco
                                    pt: 'Planta de cortiça', // Portoghese
                                    ro: 'Plută', // Rumeno
                                    sk: 'Pluta', // Slovacco
                                    sl: 'Pluta', // Sloveno
                                    es: 'Corcho', // Spagnolo
                                    sv: 'Kork', // Svedese
                                    hu: 'Kurió', // Ungherese
                                },
                                symbol: 'for-51',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'Undifferenzierte Sammlung',
                                    fr: 'Collecte indifférenciée',
                                    bg: 'Събиране на несортирани материали', // Bulgaro
                                    cs: 'Sběr nerozdělených materiálů', // Ceco
                                    hr: 'Sakupljanje nesortiranih materijala', // Croato
                                    da: 'Restaffald', // Danese
                                    et: 'Diferentseerimata kogumine', // Estone
                                    fi: 'Hajamargainen keräys', // Finlandese
                                    el: 'Αδιαχωριστή συλλογή', // Greco
                                    ga: 'Bailiú neamh-dearadh', // Irlandese
                                    lv: 'Nediferencēta vākšana', // Lettone
                                    lt: 'Neišskirstyta surinkimas', // Lituano
                                    mt: 'Ħażna mingħajr differenzjazzjoni', // Maltese
                                    nl: 'Niet-gesorteerde inzameling', // Neerlandese
                                    pl: 'Zbieranie nierozdzielone', // Polacco
                                    pt: 'Coleta indiferenciada', // Portoghese
                                    ro: 'Colectare nediferențiată', // Rumeno
                                    sk: 'Zber nerozdelených materiálov', // Slovacco
                                    sl: 'Zbiranje nerasvrstjenih materialov', // Sloveno
                                    es: 'Recogida indiferenciada', // Spagnolo
                                    sv: 'Odifferentierad insamling', // Svedese
                                    hu: 'Nem differenciált gyűjtés', // Ungherese
                                },
                            },
                            'vite-alluminio': {
                                label: {
                                    it: 'Tappi a vite in alluminio',
                                    en: 'Aluminum screw caps',
                                    de: 'Schraubkappen aus Aluminium',
                                    fr: 'Bouchons à vis en aluminium',
                                    bg: 'Алуминиеви винтови коркове', // Bulgaro
                                    cs: 'Hliníkové šroubky', // Ceco
                                    hr: 'Aluminijske vrećice u etabli', // Croato
                                    da: 'Aluminiumsskruelåg', // Danese
                                    et: 'Alumiiniumist kruvilukud', // Estone
                                    fi: 'Alumiininen ruuvikorkki', // Finlandese
                                    el: 'Αλουμινένιες βιδωτές σφραγίδες', // Greco
                                    ga: 'Coircead screiteach alumainim', // Irlandese
                                    lv: 'Alumīnija skrūvekārtas', // Lettone
                                    lt: 'Aliuminio varžtais uždangai', // Lituano
                                    mt: 'Kork screwtal-aluminiju', // Maltese
                                    nl: 'Aluminium schroefdoppen', // Neerlandese
                                    pl: 'Aluminiowe kapsle śrubowe', // Polacco
                                    pt: 'Tampas de parafuso de alumínio', // Portoghese
                                    ro: 'Capace de șurub din aluminiu', // Rumeno
                                    sk: 'Hliníkové závitové korky', // Slovacco
                                    sl: 'Aluminijaste vijakaste pene', // Sloveno
                                    es: 'Tapas de rosca de aluminio', // Spagnolo
                                    sv: 'Aluminium skruvkorkar', // Svedese
                                    hu: 'Alumínium csavaros üvegzáró', // Ungherese
                                },
                                symbol: 'c-alu-90',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung',
                                    fr: 'Collecte d\'aluminium',
                                    bg: 'Събиране на алуминий', // Bulgaro
                                    cs: 'Sběr hliníku', // Ceco
                                    hr: 'Sakupljanje aluminija', // Croato
                                    da: 'Aluminiumindsamling', // Danese
                                    et: 'Alumiiniumikogumine', // Estone
                                    fi: 'Alumiinikeräys', // Finlandese
                                    el: 'Συλλογή αλουμινίου', // Greco
                                    ga: 'Bailiú alumainim', // Irlandese
                                    lv: 'Alumīnija vākšana', // Lettone
                                    lt: 'Aliuminio surinkimas', // Lituano
                                    mt: 'Ħażna ta’ aluminiumu', // Maltese
                                    nl: 'Aluminium inzameling', // Neerlandese
                                    pl: 'Zbieranie aluminium', // Polacco
                                    pt: 'Coleta de alumínio', // Portoghese
                                    ro: 'Colectare de aluminiu', // Rumeno
                                    sk: 'Zber hliníka', // Slovacco
                                    sl: 'Zbiranje aluminija', // Sloveno
                                    es: 'Recogida de aluminio', // Spagnolo
                                    sv: 'Aluminiuminsamling', // Svedese
                                    hu: 'Alumíniumgyűjtés', // Ungherese
                                },
                            },
                            sintetici: {
                                label: {
                                    it: 'Tappi sintetici',
                                    en: 'Synthetic corks',
                                    de: 'Synthetische Korken',
                                    fr: 'Bouchons synthétiques',
                                    bg: 'Синтетични коркове', // Bulgaro
                                    cs: 'Syntetické korky', // Ceco
                                    hr: 'Sintetičke čepa', // Croato
                                    da: 'Syntetiske propper', // Danese
                                    et: 'Sünteetilised korkid', // Estone
                                    fi: 'Synteettiset korkit', // Finlandese
                                    el: 'Συνθετικοί σφραγίδες', // Greco
                                    ga: 'Cuircead synthetic', // Irlandese
                                    lv: 'Sintētiskie korki', // Lettone
                                    lt: 'Sintetiniai kamštelės', // Lituano
                                    mt: 'Corki sintetiku', // Maltese
                                    nl: 'Synthetische kurken', // Neerlandese
                                    pl: 'Syntetyczne korki', // Polacco
                                    pt: 'Tampas sintéticas', // Portoghese
                                    ro: 'Tampone sintetice', // Rumeno
                                    sk: 'Syntetické korky', // Slovacco
                                    sl: 'Sintetični čepiči', // Sloveno
                                    es: 'Corchos sintéticos', // Spagnolo
                                    sv: 'Syntetiska korkar', // Svedese
                                    hu: 'Szintetikus dugók', // Ungherese
                                },
                                symbol: 'ldpe-4',
                                destination: {
                                    it: 'Raccolta plastica',
                                    en: 'Plastic collection',
                                    de: 'Plastik Sammlung',
                                    fr: 'Collecte de plastique',
                                    bg: 'Събиране на пластмаса', // Bulgaro
                                    cs: 'Sběr plastu', // Ceco
                                    hr: 'Sakupljanje plastike', // Croato
                                    da: 'Plastindsamling', // Danese
                                    et: 'Plastikkogumine', // Estone
                                    fi: 'Muovinkeräys', // Finlandese
                                    el: 'Συλλογή πλαστικού', // Greco
                                    ga: 'Bailiú phlastaicí', // Irlandese
                                    lv: 'Plastmasas vākšana', // Lettone
                                    lt: 'Plastiko surinkimas', // Lituano
                                    mt: 'Ħażna ta’ plastiċi', // Maltese
                                    nl: 'Plastic inzameling', // Neerlandese
                                    pl: 'Zbieranie plastiku', // Polacco
                                    pt: 'Coleta de plástico', // Portoghese
                                    ro: 'Colectare de plastic', // Rumeno
                                    sk: 'Zber plastu', // Slovacco
                                    sl: 'Zbiranje plastike', // Sloveno
                                    es: 'Recogida de plástico', // Spagnolo
                                    sv: 'Plastinsamling', // Svedese
                                    hu: 'Műanyaggyűjtés', // Ungherese
                                },
                            },
                            misti: {
                                label: {
                                    it: 'Tappi sintetici / sughero',
                                    en: 'Synthetic caps / cork',
                                    de: 'Synthetische Kappen / Kork',
                                    fr: 'Bouchons synthétiques / liège',
                                    bg: 'Синтетични коркове / коркова', // Bulgaro
                                    cs: 'Syntetické korky / kork', // Ceco
                                    hr: 'Sintetički čepići / pluta', // Croato
                                    da: 'Syntetiske propper / kork', // Danese
                                    et: 'Sünteetilised korkid / kork', // Estone
                                    fi: 'Synteettiset korkit / sulkija', // Finlandese
                                    el: 'Συνθετικοί σφραγίδες / σφραγίδες', // Greco
                                    ga: 'Cuircead synthetic / cuircead', // Irlandese
                                    lv: 'Sintētiskie korki / korki', // Lettone
                                    lt: 'Sintetiniai kamštelės / kamštelės', // Lituano
                                    mt: 'Kapelli sintetiku / kapelli', // Maltese
                                    nl: 'Synthetische kurken / kurken', // Neerlandese
                                    pl: 'Syntetyczne korki / korki', // Polacco
                                    pt: 'Tampas sintéticas / cortiça', // Portoghese
                                    ro: 'Tampone sintetice / plută', // Rumeno
                                    sk: 'Syntetické korky / korky', // Slovacco
                                    sl: 'Sintetični čepiči / čepiči', // Sloveno
                                    es: 'Tapas sintéticas / corchos', // Spagnolo
                                    sv: 'Syntetiska korkar / korkar', // Svedese
                                    hu: 'Szintetikus dugók / dugók', // Ungherese
                                },
                                symbol: 'misti',
                                destination: {
                                    it: 'Raccolta plastica o Raccolta indifferenziata',
                                    en: 'Plastic or Undifferentiated collection',
                                    de: 'Kunststoff oder undifferenzierte Sammlung',
                                    fr: 'Collecte de plastique ou collecte indifférenciée',
                                    bg: 'Събиране на пластмаса или несортирани материали', // Bulgaro
                                    cs: 'Sběr plastu nebo nerozdělený sběr', // Ceco
                                    hr: 'Sakupljanje plastike ili nesortiranih materijala', // Croato
                                    da: 'Plast- eller restaffald', // Danese
                                    et: 'Plastik või diferentseerimata kogumine', // Estone
                                    fi: 'Muovi tai hajamargainen keräys', // Finlandese
                                    el: 'Συλλογή πλαστικού ή αδιαχωριστή συλλογή', // Greco
                                    ga: 'Bhailiú phlastaicí nó bailiú neamh-dhearadh', // Irlandese
                                    lv: 'Plastmasas vai nediferencēta vākšana', // Lettone
                                    lt: 'Plastiko ar neišskirstyta surinkimas', // Lituano
                                    mt: 'Ħażna ta’ plastiċi jew ħażna mingħajr differenzjazzjoni', // Maltese
                                    nl: 'Plastic of niet-gesorteerde inzameling', // Neerlandese
                                    pl: 'Zbieranie plastiku lub nierozdzielone', // Polacco
                                    pt: 'Coleta de plástico ou coleta indiferenciada', // Portoghese
                                    ro: 'Colectare de plastic sau colectare nediferențiată', // Rumeno
                                    sk: 'Zber plastu alebo zber nerozdelených materiálov', // Slovacco
                                    sl: 'Zbiranje plastike ali nerasvrstjenih materialov', // Sloveno
                                    es: 'Recogida de plástico o recogida indiferenciada', // Spagnolo
                                    sv: 'Plast eller odifferentierad insamling', // Svedese
                                    hu: 'Műanyaggyűjtés vagy nem differenciált gyűjtés', // Ungherese
                                },
                            },
                            'fungo-sintetico': {
                                label: {
                                    it: 'Tappo a fungo sintetico',
                                    en: 'Synthetic mushroom cork',
                                    de: 'Synthetischer Pilzkorken',
                                    fr: 'Bouchon en forme de champignon synthétique',
                                    bg: 'Синтетичен гъбовиден тапа',
                                    cs: 'Syntetický houbový korek',
                                    hr: 'Sintetički čep u obliku gljive',
                                    da: 'Syntetisk champagneprop',
                                    et: 'Sünteetiline seenekujuline kork',
                                    fi: 'Synteettinen sienitulppa',
                                    el: 'Συνθετικό κορκολίστρα μανιταριού',
                                    ga: 'Corc fungais shamhaiticeach',
                                    lv: 'Sintētiska sēņu formas korķis',
                                    lt: 'Sintetinis grybų formos kamštis',
                                    mt: 'Tapp ta\' fungu sintetiku',
                                    nl: 'Synthetische champignonkurk',
                                    pl: 'Syntetyczny korek w kształcie grzyba',
                                    pt: 'Rolha sintética em forma de cogumelo',
                                    ro: 'Dop de vin sintetic în formă de ciupercă',
                                    sk: 'Syntetický kork v tvare huby',
                                    sl: 'Sintetični zamašek v obliki gobe',
                                    es: 'Corcho sintético en forma de seta',
                                    sv: 'Syntetisk svampformad kork',
                                    hu: 'Szintetikus gomba alakú dugó',
                                },
                                symbol: 'c-ldpe-86',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'Undifferenzierte Sammlung',
                                    fr: 'Collecte indifférenciée',
                                    bg: 'Събиране на несортирани материали', // Bulgaro
                                    cs: 'Sběr nerozdělených materiálů', // Ceco
                                    hr: 'Sakupljanje nesortiranih materijala', // Croato
                                    da: 'Restaffald', // Danese
                                    et: 'Diferentseerimata kogumine', // Estone
                                    fi: 'Hajamargainen keräys', // Finlandese
                                    el: 'Αδιαχωριστή συλλογή', // Greco
                                    ga: 'Bailiú neamh-dearadh', // Irlandese
                                    lv: 'Nediferencēta vākšana', // Lettone
                                    lt: 'Neišskirstyta surinkimas', // Lituano
                                    mt: 'Ħażna mingħajr differenzjazzjoni', // Maltese
                                    nl: 'Niet-gesorteerde inzameling', // Neerlandese
                                    pl: 'Zbieranie nierozdzielone', // Polacco
                                    pt: 'Coleta indiferenciada', // Portoghese
                                    ro: 'Colectare nediferențiată', // Rumeno
                                    sk: 'Zber nerozdelených materiálov', // Slovacco
                                    sl: 'Zbiranje nerasvrstjenih materialov', // Sloveno
                                    es: 'Recogida indiferenciada', // Spagnolo
                                    sv: 'Odifferentierad insamling', // Svedese
                                    hu: 'Nem differenciált gyűjtés', // Ungherese
                                },
                            },
                        },
                    },
                    capsule: {
                        label: {
                            it: 'Capsula',
                            en: 'Capsule',
                            de: 'Kapsel',
                            fr: 'Capsule',
                            bg: 'Капсула', // Bulgaro
                            cs: 'Kapsle', // Ceco
                            hr: 'Kapic', // Croato
                            da: 'Kapsel', // Danese
                            et: 'Kapsel', // Estone
                            fi: 'Kapseeli', // Finlandese
                            el: 'Κάψουλα', // Greco
                            ga: 'Capsúl', // Irlandese
                            lv: 'Kapsule', // Lettone
                            lt: 'Kapsulė', // Lituano
                            mt: 'Kapċċula', // Maltese
                            nl: 'Capsule', // Neerlandese
                            pl: 'Kapselka', // Polacco
                            pt: 'Cápsula', // Portoghese
                            ro: 'Capsulă', // Rumeno
                            sk: 'Kapsula', // Slovacco
                            sl: 'Pena', // Sloveno
                            es: 'Cápsula', // Spagnolo
                            sv: 'Kapsel', // Svedese
                            hu: 'Kopors', // Ungherese
                        },
                        materials: {
                            pvc: {
                                label: {
                                    it: 'Termoretraibili in PVC',
                                    en: 'PVC shrink wrap',
                                    de: 'PVC-Schrumpffolie',
                                    fr: 'Enveloppes thermorétractables en PVC',
                                    bg: 'PVC термоусукваемо покритие', // Bulgaro
                                    cs: 'PVC smrštovací fólie', // Ceco
                                    hr: 'PVC skupljiva folija', // Croato
                                    da: 'Krympekapsel af PVC', // Danese
                                    et: 'PVC kahjustetuv kile', // Estone
                                    fi: 'PVC:hen termusuoni', // Finlandese
                                    el: 'Ταινία συρρίκνωσης PVC', // Greco
                                    ga: 'Treocmhéara PVC', // Irlandese
                                    lv: 'PVC salcināmas apvalkumi', // Lettone
                                    lt: 'PVC susitraukimo plėvelė', // Lituano
                                    mt: 'Ħwira termoriterċisjuja f’PVC', // Maltese
                                    nl: 'PVC krimpfolie', // Neerlandese
                                    pl: 'PVC folia kurcząca się', // Polacco
                                    pt: 'Embalagem retrátil de PVC', // Portoghese
                                    ro: 'Înveliș retractabil din PVC', // Rumeno
                                    sk: 'PVC smršťovacia fólia', // Slovacco
                                    sl: 'PVC skrčljivo folijo', // Sloveno
                                    es: 'Envoltura retráctil de PVC', // Spagnolo
                                    sv: 'PVC-skrumpfolie', // Svedese
                                    hu: 'PVC megrepítő fólia', // Ungherese
                                },
                                symbol: 'c-pvc-90',
                                destination: {
                                    it: 'Raccolta plastica',
                                    en: 'Plastic collection',
                                    de: 'Plastik Sammlung',
                                    fr: 'Collecte de plastique',
                                    bg: 'Събиране на пластмаса',
                                    cs: 'Sběr plastu',
                                    hr: 'Sakupljanje plastike',
                                    da: 'Plastindsamling',
                                    et: 'Plastikkogumine',
                                    fi: 'Muovinkeräys',
                                    el: 'Συλλογή πλαστικού',
                                    ga: 'Bailiú phlastaicí',
                                    lv: 'Plastmasas vākšana',
                                    lt: 'Plastiko surinkimas',
                                    mt: 'Ħażna ta’ plastiċi',
                                    nl: 'Plastic inzameling',
                                    pl: 'Zbieranie plastiku',
                                    pt: 'Coleta de plástico',
                                    ro: 'Colectare de plastic',
                                    sk: 'Zber plastu',
                                    sl: 'Zbiranje plastike',
                                    es: 'Recogida de plástico',
                                    sv: 'Plastinsamling',
                                    hu: 'Műanyaggyűjtés',
                                },
                            },
                            pet: {
                                label: {
                                    it: 'Termoretraibili in PET',
                                    en: 'PET shrink wrap',
                                    de: 'PET-Schrumpffolie',
                                    fr: 'Enveloppes thermorétractables en PET',
                                    bg: 'PET термоусукваемо покритие', // Bulgaro
                                    cs: 'PET smrštovací fólie', // Ceco
                                    hr: 'PET skupljiva folija', // Croato
                                    da: 'Krympekapsel af PET', // Danese
                                    et: 'PET kahjustetuv kile', // Estone
                                    fi: 'PET:hen termusuoni', // Finlandese
                                    el: 'Ταινία συρρίκνωσης PET', // Greco
                                    ga: 'Treocmhéara PET', // Irlandese
                                    lv: 'PET salcināmas apvalkumi', // Lettone
                                    lt: 'PET susitraukimo plėvelė', // Lituano
                                    mt: 'Ħwira termoriterċisjuja f’PET', // Maltese
                                    nl: 'PET krimpfolie', // Neerlandese
                                    pl: 'PET folia kurcząca się', // Polacco
                                    pt: 'Embalagem retrátil de PET', // Portoghese
                                    ro: 'Înveliș retractabil din PET', // Rumeno
                                    sk: 'PET smršťovacia fólia', // Slovacco
                                    sl: 'PET skrčljivo folijo', // Sloveno
                                    es: 'Envoltura retráctil de PET', // Spagnolo
                                    sv: 'PET-skrumpfolie', // Svedese
                                    hu: 'PET megrepítő fólia', // Ungherese
                                },
                                symbol: 'c-pet-90',
                                destination: {
                                    it: 'Raccolta plastica',
                                    en: 'Plastic collection',
                                    de: 'Plastik Sammlung',
                                    fr: 'Collecte de plastique',
                                    bg: 'Събиране на пластмаса',
                                    cs: 'Sběr plastu',
                                    hr: 'Sakupljanje plastike',
                                    da: 'Plastindsamling',
                                    et: 'Plastikkogumine',
                                    fi: 'Muovinkeräys',
                                    el: 'Συλλογή πλαστικού',
                                    ga: 'Bailiú phlastaicí',
                                    lv: 'Plastmasas vākšana',
                                    lt: 'Plastiko surinkimas',
                                    mt: 'Ħażna ta’ plastiċi',
                                    nl: 'Plastic inzameling',
                                    pl: 'Zbieranie plastiku',
                                    pt: 'Coleta de plástico',
                                    ro: 'Colectare de plastic',
                                    sk: 'Zber plastu',
                                    sl: 'Zbiranje plastike',
                                    es: 'Recogida de plástico',
                                    sv: 'Plastinsamling',
                                    hu: 'Műanyaggyűjtés',
                                },
                            },
                            stagno: {
                                label: {
                                    it: 'Capsule in stagno',
                                    en: 'Tin capsules',
                                    de: 'Kapseln aus Zinn',
                                    fr: 'Capsules en étain',
                                    bg: 'Капсули от каша', // Bulgaro
                                    cs: 'Olovené kapsle', // Ceco
                                    hr: 'Kupice od kositra', // Croato
                                    da: 'Tinkapsler', // Danese
                                    et: 'Pinni kapslid', // Estone
                                    fi: 'Tinakapseleet', // Finlandese
                                    el: 'Κάψουλες από σίδηρο', // Greco
                                    ga: 'Capsúl tin', // Irlandese
                                    lv: 'Cinka kapsules', // Lettone
                                    lt: 'Cinko kapsulės', // Lituano
                                    mt: 'Kapċuli tal-inġebna', // Maltese
                                    nl: 'Tin kapsels', // Neerlandese
                                    pl: 'Kapsle cynkowe', // Polacco
                                    pt: 'Cápsulas de lata', // Portoghese
                                    ro: 'Capsule de tablă', // Rumeno
                                    sk: 'Cínové kapsle', // Slovacco
                                    sl: 'Cinkaste pene', // Sloveno
                                    es: 'Cápsulas de estaño', // Spagnolo
                                    sv: 'Tinkapslar', // Svedese
                                    hu: 'Cinkakapszulák', // Ungherese
                                },
                                symbol: 'tin-42',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung',
                                    fr: 'Collecte d\'aluminium',
                                    bg: 'Събиране на алуминий',
                                    cs: 'Sběr hliníku',
                                    hr: 'Sakupljanje aluminija',
                                    da: 'Aluminiumindsamling',
                                    et: 'Alumiiniumikogumine',
                                    fi: 'Alumiinikeräys',
                                    el: 'Συλλογή αλουμινίου',
                                    ga: 'Bailiú alumainim',
                                    lv: 'Alumīnija vākšana',
                                    lt: 'Aliuminio surinkimas',
                                    mt: 'Ħażna ta’ aluminiumu',
                                    nl: 'Aluminium inzameling',
                                    pl: 'Zbieranie aluminium',
                                    pt: 'Coleta de alumínio',
                                    ro: 'Colectare de aluminiu',
                                    sk: 'Zber hliníka',
                                    sl: 'Zbiranje aluminija',
                                    es: 'Recogida de aluminio',
                                    sv: 'Aluminiuminsamling',
                                    hu: 'Alumíniumgyűjtés',
                                },
                            },
                            alluminio: {
                                label: {
                                    it: 'Capsule polilaminato - alluminio',
                                    en: 'Polylaminate capsules - aluminum',
                                    de: 'Kapseln aus Polylaminat - Aluminium',
                                    fr: 'Capsules en polylaminé - aluminium',
                                    bg: 'Полиламина капсули - алуминий', // Bulgaro
                                    cs: 'Polylaminátové kapsle - hliník', // Ceco
                                    hr: 'Polilaminati kupice - aluminij', // Croato
                                    da: 'Polylaminatkapsler – aluminium', // Danese
                                    et: 'Polülaminaad kapslid - alumiinium', // Estone
                                    fi: 'Polylaminaattiset kapselit - alumiini', // Finlandese
                                    el: 'Πολυλαμινασμένες κάψουλες - αλουμίνιο', // Greco
                                    ga: 'Capsúl polylaminate - alumainim', // Irlandese
                                    lv: 'Polilaminate kapsulas - alumīnijs', // Lettone
                                    lt: 'Polilaminato kapsulės - aliuminis', // Lituano
                                    mt: 'Kapċuli tal-polilaminat - aluminiju', // Maltese
                                    nl: 'Polylamineen kapsels - aluminium', // Neerlandese
                                    pl: 'Kapsle polilaminowe - aluminium', // Polacco
                                    pt: 'Capsulas de poliaminado - alumínio', // Portoghese
                                    ro: 'Capsule de polilaminat - aluminiu', // Rumeno
                                    sk: 'Polylaminate kapsle - hliník', // Slovacco
                                    sl: 'Polilaminatne pene - aluminij', // Sloveno
                                    es: 'Capsulas de polilaminato - aluminio', // Spagnolo
                                    sv: 'Polylaminatkapslar - aluminium', // Svedese
                                    hu: 'Polilaminát kapszulák - alumínium', // Ungherese
                                },
                                symbol: 'c-alu-90',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung',
                                    fr: 'Collecte d\'aluminium',
                                    bg: 'Събиране на алуминий',
                                    cs: 'Sběr hliníku',
                                    hr: 'Sakupljanje aluminija',
                                    da: 'Aluminiumindsamling',
                                    et: 'Alumiiniumikogumine',
                                    fi: 'Alumiinikeräys',
                                    el: 'Συλλογή αλουμινίου',
                                    ga: 'Bailiú alumainim',
                                    lv: 'Alumīnija vākšana',
                                    lt: 'Aliuminio surinkimas',
                                    mt: 'Ħażna ta’ aluminiumu',
                                    nl: 'Aluminium inzameling',
                                    pl: 'Zbieranie aluminium',
                                    pt: 'Coleta de alumínio',
                                    ro: 'Colectare de aluminiu',
                                    sk: 'Zber hliníka',
                                    sl: 'Zbiranje aluminija',
                                    es: 'Recogida de aluminio',
                                    sv: 'Aluminiuminsamling',
                                    hu: 'Alumíniumgyűjtés',
                                },
                            },
                            ceralacca: {
                                label: {
                                    it: 'Capsule in ceralacca',
                                    en: 'Wax capsules',
                                    de: 'Wachskapseln',
                                    fr: 'Capsules en cire',
                                    bg: 'Капсули от восък',
                                    cs: 'Voskové kapsle',
                                    hr: 'Voske kapsule',
                                    da: 'Vokskapsler',
                                    et: 'Vahukapslid',
                                    fi: 'Vahakapselit',
                                    el: 'Κάψουλες κερί',
                                    ga: 'Cápsúláin uala',
                                    lv: 'Vaska kapsulas',
                                    lt: 'Vaško kapsulės',
                                    mt: 'Kapżoli tal-xebbieb',
                                    nl: 'Waskaapsels',
                                    pl: 'Kapsułki woskowe',
                                    pt: 'Cápsulas de cera',
                                    ro: 'Capsule de ceară',
                                    sk: 'Voskové kapsule',
                                    sl: 'Voske kapsule',
                                    es: 'Cápsulas de cera',
                                    sv: 'Vaxkapslar',
                                    hu: 'Viaskapszulák'
                                },
                                symbol: 'c-pi',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'Undifferenzierte Sammlung',
                                    fr: 'Collecte indifférenciée',
                                    bg: 'Събиране на несортирани материали',
                                    cs: 'Sběr nerozdělených materiálů',
                                    hr: 'Sakupljanje nesortiranih materijala',
                                    da: 'Restaffald',
                                    et: 'Diferentseerimata kogumine',
                                    fi: 'Hajamargainen keräys',
                                    el: 'Αδιαχωριστή συλλογή',
                                    ga: 'Bailiú neamh-dearadh',
                                    lv: 'Nediferencēta vākšana',
                                    lt: 'Neišskirstyta surinkimas',
                                    mt: 'Ħażna mingħajr differenzjazzjoni',
                                    nl: 'Niet-gesorteerde inzameling',
                                    pl: 'Zbieranie nierozdzielone',
                                    pt: 'Coleta indiferenciada',
                                    ro: 'Colectare nediferențiată',
                                    sk: 'Zber nerozdelených materiálov',
                                    sl: 'Zbiranje nerasvrstjenih materialov',
                                    es: 'Recogida indiferenciada',
                                    sv: 'Odifferentierad insamling',
                                    hu: 'Nem differenciált gyűjtés',
                                },
                            },
                        },
                    },
                    gabbietta: {
                        label: {
                            it: 'Gabbietta',
                            en: 'Cage',
                            de: 'Käfig',
                            fr: 'Cage',
                            bg: 'Клетка', // Bulgaro
                            cs: 'Klec', // Ceco
                            hr: 'Kaveza', // Croato
                            da: 'Trådkurv', // Danese
                            et: 'Kavut', // Estone
                            fi: 'Häkki', // Finlandese
                            el: 'Κλουβί', // Greco
                            ga: 'Cáis', // Irlandese
                            lv: 'Kaķējs', // Lettone
                            lt: 'Klaustas', // Lituano
                            mt: 'Kaxxa', // Maltese
                            nl: 'Kooi', // Neerlandese
                            pl: 'Klatka', // Polacco
                            pt: 'Gaiola', // Portoghese
                            ro: 'Cușcă', // Rumeno
                            sk: 'Kleca', // Slovacco
                            sl: 'Kavez', // Sloveno
                            es: 'Jaula', // Spagnolo
                            sv: 'Kravall', // Svedese
                            hu: 'Kefegyűrű', // Ungherese
                        },
                        materials: {
                            acciaio: {
                                label: {
                                    it: 'Termoretraibili in PVC',
                                    en: 'PVC shrink wrap',
                                    de: 'PVC-Schrumpffolie',
                                    fr: 'Enveloppes thermorétractables en PVC',
                                    bg: 'PVC термоусукваемо покритие', // Bulgaro
                                    cs: 'PVC smrštovací fólie', // Ceco
                                    hr: 'PVC skupljiva folija', // Croato
                                    da: 'Ståltråd', // Danese
                                    et: 'PVC kahjustetuv kile', // Estone
                                    fi: 'PVC:hen termusuoni', // Finlandese
                                    el: 'Ταινία συρρίκνωσης PVC', // Greco
                                    ga: 'Treocmhéara PVC', // Irlandese
                                    lv: 'PVC salcināmas apvalkumi', // Lettone
                                    lt: 'PVC susitraukimo plėvelė', // Lituano
                                    mt: 'Ħwira termoriterċisjuja f’PVC', // Maltese
                                    nl: 'PVC krimpfolie', // Neerlandese
                                    pl: 'PVC folia kurcząca się', // Polacco
                                    pt: 'Embalagem retrátil de PVC', // Portoghese
                                    ro: 'Înveliș retractabil din PVC', // Rumeno
                                    sk: 'PVC smršťovacia fólia', // Slovacco
                                    sl: 'PVC skrčljivo folijo', // Sloveno
                                    es: 'Envoltura retráctil de PVC', // Spagnolo
                                    sv: 'PVC-skrumpfolie', // Svedese
                                    hu: 'PVC megrepítő fólia', // Ungherese
                                },
                                symbol: 'fe-40',
                                destination: {
                                    it: 'Raccolta acciaio',
                                    en: 'Steel collection',
                                    de: 'Stahlsammlung',
                                    fr: 'Collecte d\'acier',
                                    bg: 'Събиране на стомана', // Bulgaro
                                    cs: 'Sběr oceli', // Ceco
                                    hr: 'Sakupljanje čelika', // Croato
                                    da: 'Metalindsamling', // Danese
                                    et: 'Terase kogumine', // Estone
                                    fi: 'Teräksen keräys', // Finlandese
                                    el: 'Συλλογή χάλυβα', // Greco
                                    ga: 'Bailiú ciail', // Irlandese
                                    lv: 'Tērauda vākšana', // Lettone
                                    lt: 'Plieno surinkimas', // Lituano
                                    mt: 'Ħażna ta’ tal-każel', // Maltese
                                    nl: 'Staal inzameling', // Neerlandese
                                    pl: 'Zbieranie stali', // Polacco
                                    pt: 'Coleta de aço', // Portoghese
                                    ro: 'Colectare de oțel', // Rumeno
                                    sk: 'Zber ocele', // Slovacco
                                    sl: 'Zbiranje jekla', // Sloveno
                                    es: 'Recogida de acero', // Spagnolo
                                    sv: 'Stålinsamling', // Svedese
                                    hu: 'Acélgyűjtés', // Ungherese
                                },
                            },
                        },
                    },
                    cartone: {
                        label: {
                            it: 'Cartone',
                            en: 'Cardboard',
                            de: 'Karton',
                            fr: 'Carton',
                            bg: 'Картон', // Bulgaro
                            cs: 'Kartón', // Ceco
                            hr: 'Kartonska kutija', // Croato
                            da: 'Papemballage', // Danese
                            et: 'Karton', // Estone
                            fi: 'Pahvi', // Finlandese
                            el: 'Κάρτον', // Greco
                            ga: 'Cartón', // Irlandese
                            lv: 'Kartons', // Lettone
                            lt: 'Kartonė', // Lituano
                            mt: 'Kartun', // Maltese
                            nl: 'Karton', // Neerlandese
                            pl: 'Karton', // Polacco
                            pt: 'Cardboard', // Portoghese
                            ro: 'Carton', // Rumeno
                            sk: 'Karton', // Slovacco
                            sl: 'Kartonski', // Sloveno
                            es: 'Cartón', // Spagnolo
                            sv: 'Karton', // Svedese
                            hu: 'Karton', // Ungherese
                        },
                        materials: {
                            cartoni: {
                                label: {
                                    it: 'Cartoni',
                                    en: 'Cardboard',
                                    de: 'Karton',
                                    fr: 'Cartons',
                                    bg: 'Картончета', // Bulgaro
                                    cs: 'Kartóny', // Ceco
                                    hr: 'Kartoni', // Croato
                                    da: 'Karton', // Danese
                                    et: 'Kartongid', // Estone
                                    fi: 'Pappeja', // Finlandese
                                    el: 'Καρτόνια', // Greco
                                    ga: 'Cartón', // Irlandese
                                    lv: 'Kartoni', // Lettone
                                    lt: 'Kartonai', // Lituano
                                    mt: 'Kartonni', // Maltese
                                    nl: 'Kartonnen', // Neerlandese
                                    pl: 'Karton', // Polacco
                                    pt: 'Cartões', // Portoghese
                                    ro: 'Cartoane', // Rumeno
                                    sk: 'Kartóny', // Slovacco
                                    sl: 'Kartoni', // Sloveno
                                    es: 'Cartones', // Spagnolo
                                    sv: 'Karton', // Svedese
                                    hu: 'Kartonok', // Ungherese
                                },
                                symbol: 'pap-20',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung',
                                    fr: 'Collecte de papier',
                                    bg: 'Събиране на хартия', // Bulgaro
                                    cs: 'Sběr papíru', // Ceco
                                    hr: 'Sakupljanje papira', // Croato
                                    da: 'Pap- og papirindsamling', // Danese
                                    et: 'Paberikogumine', // Estone
                                    fi: 'Paperinkeräys', // Finlandese
                                    el: 'Συλλογή χαρτιού', // Greco
                                    ga: 'Bailiú páipéir', // Irlandese
                                    lv: 'Papīra vākšana', // Lettone
                                    lt: 'Popieriaus surinkimas', // Lituano
                                    mt: 'Ħażna ta’ carta', // Maltese
                                    nl: 'Papierinzameling', // Neerlandese
                                    pl: 'Zbieranie papieru', // Polacco
                                    pt: 'Coleta de papel', // Portoghese
                                    ro: 'Colectare de hârtie', // Rumeno
                                    sk: 'Zber papiera', // Slovacco
                                    sl: 'Zbiranje papirja', // Sloveno
                                    es: 'Recogida de papel', // Spagnolo
                                    sv: 'Pappersinsamling', // Svedese
                                    hu: 'Papírgolyászat', // Ungherese
                                },
                            },
                        },
                    },
                    alveare: {
                        label: {
                            it: 'Alveare',
                            en: 'Hive',
                            de: 'Bienenstock',
                            fr: 'Alvéole',
                            bg: 'Косяк', // Bulgaro
                            cs: 'Roj', // Ceco
                            hr: 'Košnica', // Croato
                            da: 'Papindsats', // Danese
                            et: 'Mesila', // Estone
                            fi: 'Mehiläiskaso', // Finlandese
                            el: 'Κουρίδα', // Greco
                            ga: 'Hadres', // Irlandese
                            lv: 'Vesne', // Lettone
                            lt: 'Bitės lizdas', // Lituano
                            mt: 'Baljan', // Maltese
                            nl: 'Bijenkorf', // Neerlandese
                            pl: 'Ul', // Polacco
                            pt: 'Colmeia', // Portoghese
                            ro: 'Stup', // Rumeno
                            sk: 'Úľ', // Slovacco
                            sl: 'Čebelar', // Sloveno
                            es: 'Colmena', // Spagnolo
                            sv: 'Biobruk', // Svedese
                            hu: 'Kaptár', // Ungherese
                        },
                        materials: {
                            cartoni: {
                                label: {
                                    it: 'Cartoni',
                                    en: 'Cardboard',
                                    de: 'Karton',
                                    fr: 'Cartons',
                                    bg: 'Картончета', // Bulgaro
                                    cs: 'Kartóny', // Ceco
                                    hr: 'Kartoni', // Croato
                                    da: 'Karton', // Danese
                                    et: 'Kartongid', // Estone
                                    fi: 'Pappeja', // Finlandese
                                    el: 'Καρτόνια', // Greco
                                    ga: 'Cartón', // Irlandese
                                    lv: 'Kartoni', // Lettone
                                    lt: 'Kartonai', // Lituano
                                    mt: 'Kartonni', // Maltese
                                    nl: 'Kartonnen', // Neerlandese
                                    pl: 'Karton', // Polacco
                                    pt: 'Cartões', // Portoghese
                                    ro: 'Cartoane', // Rumeno
                                    sk: 'Kartóny', // Slovacco
                                    sl: 'Kartoni', // Sloveno
                                    es: 'Cartones', // Spagnolo
                                    sv: 'Karton', // Svedese
                                    hu: 'Kartonok', // Ungherese
                                },
                                symbol: 'pap-21',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung',
                                    fr: 'Collecte de papier',
                                    bg: 'Събиране на хартия',
                                    cs: 'Sběr papíru',
                                    hr: 'Sakupljanje papira',
                                    da: 'Pap- og papirindsamling',
                                    et: 'Paberikogumine',
                                    fi: 'Paperinkeräys',
                                    el: 'Συλλογή χαρτιού',
                                    ga: 'Bailiú páipéir',
                                    lv: 'Papīra vākšana',
                                    lt: 'Popieriaus surinkimas',
                                    mt: 'Ħażna ta’ carta',
                                    nl: 'Papierinzameling',
                                    pl: 'Zbieranie papieru',
                                    pt: 'Coleta de papel',
                                    ro: 'Colectare de hârtie',
                                    sk: 'Zber papiera',
                                    sl: 'Zbiranje papirja',
                                    es: 'Recogida de papel',
                                    sv: 'Pappersinsamling',
                                    hu: 'Papírgolyászat',
                                },
                            },
                        },
                    },
                    cassa: {
                        label: {
                            it: 'Cassa di legno',
                            en: 'Wooden box',
                            de: 'Holzkasten',
                            fr: 'Caisse en bois',
                            bg: 'Дървена кутия', // Bulgaro
                            cs: 'Dřevěná skříň', // Ceco
                            hr: 'Drvena kutija', // Croato
                            da: 'Trækasse', // Danese
                            et: 'Puitkast', // Estone
                            fi: 'Puulaatikko', // Finlandese
                            el: 'Ξύλινο κουτί', // Greco
                            ga: 'Caisleán adhmaid', // Irlandese
                            lv: 'Koka kastele', // Lettone
                            lt: 'Medinė dėžė', // Lituano
                            mt: 'Kutija tid-darba', // Maltese
                            nl: 'Houten kist', // Neerlandese
                            pl: 'Drewniana skrzynia', // Polacco
                            pt: 'Caixa de madeira', // Portoghese
                            ro: 'Cutie de lemn', // Rumeno
                            sk: 'Drevená skrinka', // Slovacco
                            sl: 'Lesena škatla', // Sloveno
                            es: 'Caja de madera', // Spagnolo
                            sv: 'Träkiste', // Svedese
                            hu: 'Fa doboz', // Ungherese
                        },
                        materials: {
                            legno: {
                                label: {
                                    it: 'Legno',
                                    en: 'Wood',
                                    de: 'Holz',
                                    fr: 'Bois',
                                    bg: 'Дърво', // Bulgaro
                                    cs: 'Dřevo', // Ceco
                                    hr: 'Drvo', // Croato
                                    da: 'Træ', // Danese
                                    et: 'Puit', // Estone
                                    fi: 'Puu', // Finlandese
                                    el: 'Ξύλο', // Greco
                                    ga: 'Adhmaid', // Irlandese
                                    lv: 'Koks', // Lettone
                                    lt: 'Mediena', // Lituano
                                    mt: 'Darba', // Maltese
                                    nl: 'Hout', // Neerlandese
                                    pl: 'Drewno', // Polacco
                                    pt: 'Madeira', // Portoghese
                                    ro: 'Lemn', // Rumeno
                                    sk: 'Drevo', // Slovacco
                                    sl: 'Les', // Sloveno
                                    es: 'Madera', // Spagnolo
                                    sv: 'Trä', // Svedese
                                    hu: 'Fa', // Ungherese
                                },
                                symbol: 'for-50',
                                destination: {
                                    it: 'Raccolta indifferenziata',
                                    en: 'Undifferentiated collection',
                                    de: 'Undifferenzierte Sammlung',
                                    fr: 'Collecte indifférenciée',
                                    bg: 'Събиране на несортирани материали',
                                    cs: 'Sběr nerozdělených materiálů',
                                    hr: 'Sakupljanje nesortiranih materijala',
                                    da: 'Restaffald',
                                    et: 'Diferentseerimata kogumine',
                                    fi: 'Hajamargainen keräys',
                                    el: 'Αδιαχωριστή συλλογή',
                                    ga: 'Bailiú neamh-dearadh',
                                    lv: 'Nediferencēta vākšana',
                                    lt: 'Neišskirstyta surinkimas',
                                    mt: 'Ħażna mingħajr differenzjazzjoni',
                                    nl: 'Niet-gesorteerde inzameling',
                                    pl: 'Zbieranie nierozdzielone',
                                    pt: 'Coleta indiferenciada',
                                    ro: 'Colectare nediferențiată',
                                    sk: 'Zber nerozdelených materiálov',
                                    sl: 'Zbiranje nerasvrstjenih materialov',
                                    es: 'Recogida indiferenciada',
                                    sv: 'Odifferentierad insamling',
                                    hu: 'Nem differenciált gyűjtés',
                                },
                            },
                        },
                    },
                    lattina: {
                        label: {
                            it: 'Lattina',
                            en: 'Tin can',
                            de: 'Blechdose',
                            fr: 'Boîte',
                            bg: 'Каша', // Bulgaro
                            cs: 'Plechovka', // Ceco
                            hr: 'Tinjska limenka', // Croato
                            da: 'Dåse', // Danese
                            et: 'Pindi purk', // Estone
                            fi: 'Purkkalasi', // Finlandese
                            el: 'Κασέτα', // Greco
                            ga: 'Caneanna', // Irlandese
                            lv: 'Sīnī kutenis', // Lettone
                            lt: 'Spindulio dėžė', // Lituano
                            mt: 'Redi żbin', // Maltese
                            nl: 'Blik', // Neerlandese
                            pl: 'Puszka', // Polacco
                            pt: 'Lata', // Portoghese
                            ro: 'Cutie de tablă', // Rumeno
                            sk: 'Plechovka', // Slovacco
                            sl: 'Pjenca', // Sloveno
                            es: 'Lata', // Spagnolo
                            sv: 'Blygdosa', // Svedese
                            hu: 'Agyagacél lata', // Ungherese
                        },
                        materials: {
                            lattina: {
                                label: {
                                    it: 'Lattina',
                                    en: 'Tin',
                                    de: 'Zinn',
                                    fr: 'Étain',
                                    bg: 'Киша', // Bulgaro
                                    cs: 'Cín', // Ceco
                                    hr: 'Košuta', // Croato
                                    da: 'Aluminiumsdåse', // Danese
                                    et: 'Kihv', // Estone
                                    fi: 'Tinanlaakso', // Finlandese
                                    el: 'Κασέτα από κασσίτερο', // Greco
                                    ga: 'Caneanna', // Irlandese
                                    lv: 'Cinka', // Lettone
                                    lt: 'Varžčio,', // Lituano
                                    mt: 'Żibna redi', // Maltese
                                    nl: 'Tin', // Neerlandese
                                    pl: 'Cyna', // Polacco
                                    pt: 'Estanho', // Portoghese
                                    ro: 'Caisă', // Rumeno
                                    sk: 'Cín', // Slovacco
                                    sl: 'Kasa', // Sloveno
                                    es: 'Estaño', // Spagnolo
                                    sv: 'Tenn', // Svedese
                                    hu: 'Cinic', // Ungherese
                                },
                                symbol: 'alu-41',
                                destination: {
                                    it: 'Raccolta alluminio',
                                    en: 'Aluminum collection',
                                    de: 'Aluminium Sammlung',
                                    fr: 'Collecte d\'aluminium',
                                    bg: 'Събиране на алуминий',
                                    cs: 'Sběr hliníku',
                                    hr: 'Sakupljanje aluminija',
                                    da: 'Metalindsamling',
                                    et: 'Alumiiniumikogumine',
                                    fi: 'Alumiinikeräys',
                                    el: 'Συλλογή αλουμινίου',
                                    ga: 'Bailiú alumainim',
                                    lv: 'Alumīnija vākšana',
                                    lt: 'Aliuminio surinkimas',
                                    mt: 'Ħażna ta’ aluminiumu',
                                    nl: 'Aluminium inzameling',
                                    pl: 'Zbieranie aluminium',
                                    pt: 'Coleta de alumínio',
                                    ro: 'Colectare de aluminiu',
                                    sk: 'Zber hliníka',
                                    sl: 'Zbiranje aluminija',
                                    es: 'Recogida de aluminio',
                                    sv: 'Aluminiuminsamling',
                                    hu: 'Alumíniumgyűjtés',
                                },
                            },
                        },
                    },
                    sacchetto: {
                        label: {
                            it: 'Velina / sacchetto bottiglia',
                            en: 'Paper / Bottle bag',
                            de: 'Papier / Flaschentaschen',
                            fr: 'Papier / Sac bouteille',
                            bg: 'Хартия / Чанта за бутилки', // Bulgaro
                            cs: 'Papírový taška / taška na láhve', // Ceco
                            hr: 'Papirnati vrećica / vrećica za flaše', // Croato
                            da: 'Silkepapir / flaskepose', // Danese
                            et: 'Paberkott / pudelikoorem', // Estone
                            fi: 'Paperikassi / pullovarasto', // Finlandese
                            el: 'Χαρτί / Τσάντα μπουκάλια', // Greco
                            ga: 'Mála páipéir / mála botail', // Irlandese
                            lv: 'Papīra soma / pudeļu soma', // Lettone
                            lt: 'Popierinė krepšelis / butelių krepšelis', // Lituano
                            mt: 'S-aħra ta’ carta / tagħna għal botelli', // Maltese
                            nl: 'Papieren / Fleszakje', // Neerlandese
                            pl: 'Papierowa torebka / torebka na butelki', // Polacco
                            pt: 'Saco de papel / Saco para garrafas', // Portoghese
                            ro: 'Geanta de hârtie / geantă pentru sticle', // Rumeno
                            sk: 'Papierová taška / taška na fľaše', // Slovacco
                            sl: 'Papirnata vreča / vreča za steklenice', // Sloveno
                            es: 'Bolsa de papel / bolsa para botellas', // Spagnolo
                            sv: 'Papp- / Flaskpåse', // Svedese
                            hu: 'Papírszaty / Palacktáska', // Ungherese
                        },
                        materials: {
                            carta: {
                                label: {
                                    it: 'Carta',
                                    en: 'Paper',
                                    de: 'Papier',
                                    fr: 'Papier',
                                    bg: 'Хартия', // Bulgaro
                                    cs: 'Papír', // Ceco
                                    hr: 'Papir', // Croato
                                    da: 'Papir', // Danese
                                    et: 'Paber', // Estone
                                    fi: 'Paperi', // Finlandese
                                    el: 'Χαρτί', // Greco
                                    ga: 'Páipéar', // Irlandese
                                    lv: 'Papīrs', // Lettone
                                    lt: 'Popierius', // Lituano
                                    mt: 'Carta', // Maltese
                                    nl: 'Papier', // Neerlandese
                                    pl: 'Papier', // Polacco
                                    pt: 'Papel', // Portoghese
                                    ro: 'Hartie', // Rumeno
                                    sk: 'Papiera', // Slovacco
                                    sl: 'Papir', // Sloveno
                                    es: 'Papel', // Spagnolo
                                    sv: 'Papper', // Svedese
                                    hu: 'Papír', // Ungherese
                                },
                                symbol: 'pap-22',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung',
                                    fr: 'Collecte de papier',
                                    bg: 'Събиране на хартия',
                                    cs: 'Sběr papíru',
                                    hr: 'Sakupljanje papira',
                                    da: 'Pap- og papirindsamling',
                                    et: 'Paberikogumine',
                                    fi: 'Paperinkeräys',
                                    el: 'Συλλογή χαρτιού',
                                    ga: 'Bailiú páipéir',
                                    lv: 'Papīra vākšana',
                                    lt: 'Popieriaus surinkimas',
                                    mt: 'Ħażna ta’ carta',
                                    nl: 'Papierinzameling',
                                    pl: 'Zbieranie papieru',
                                    pt: 'Coleta de papel',
                                    ro: 'Colectare de hârtie',
                                    sk: 'Zber papiera',
                                    sl: 'Zbiranje papirja',
                                    es: 'Recogida de papel',
                                    sv: 'Pappersinsamling',
                                    hu: 'Papírgolyászat',
                                },
                            },
                        },
                    },
                    pendaglio: {
                        label: {
                            it: 'Pendaglio',
                            en: 'Pendant',
                            de: 'Anhänger',
                            fr: 'Étiquette',
                            bg: 'Ониекла', // Bulgaro
                            cs: 'Přívěsek', // Ceco
                            hr: 'Privesak', // Croato
                            da: 'Hængemærke', // Danese
                            et: 'Riputus', // Estone
                            fi: 'Koriste', // Finlandese
                            el: 'Κρεμάστρα', // Greco
                            ga: 'Pachntaint', // Irlandese
                            lv: 'Piedevums', // Lettone
                            lt: 'Pakabukas', // Lituano
                            mt: 'Pendenti', // Maltese
                            nl: 'Anhanger', // Neerlandese
                            pl: 'Wisiorek', // Polacco
                            pt: 'Pendente', // Portoghese
                            ro: 'Pandantivă', // Rumeno
                            sk: 'Přívesok', // Slovacco
                            sl: 'Penda', // Sloveno
                            es: 'Colgante', // Spagnolo
                            sv: 'Hängsmycke', // Svedese
                            hu: 'Medál', // Ungherese
                        },
                        materials: {
                            carta: {
                                label: {
                                    it: 'Carta',
                                    en: 'Paper',
                                    de: 'Papier',
                                    fr: 'Papier',
                                    bg: 'Хартия', // Bulgaro
                                    cs: 'Papír', // Ceco
                                    hr: 'Papir', // Croato
                                    da: 'Papir', // Danese
                                    et: 'Paber', // Estone
                                    fi: 'Paperi', // Finlandese
                                    el: 'Χαρτί', // Greco
                                    ga: 'Páipéar', // Irlandese
                                    lv: 'Papīrs', // Lettone
                                    lt: 'Popierius', // Lituano
                                    mt: 'Carta', // Maltese
                                    nl: 'Papier', // Neerlandese
                                    pl: 'Papier', // Polacco
                                    pt: 'Papel', // Portoghese
                                    ro: 'Hartie', // Rumeno
                                    sk: 'Papiera', // Slovacco
                                    sl: 'Papir', // Sloveno
                                    es: 'Papel', // Spagnolo
                                    sv: 'Papper', // Svedese
                                    hu: 'Papír', // Ungherese
                                },
                                symbol: 'pap-22',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung',
                                    fr: 'Collecte de papier',
                                    bg: 'Събиране на хартия',
                                    cs: 'Sběr papíru',
                                    hr: 'Sakupljanje papira',
                                    da: 'Pap- og papirindsamling',
                                    et: 'Paberikogumine',
                                    fi: 'Paperinkeräys',
                                    el: 'Συλλογή χαρτιού',
                                    ga: 'Bailiú páipéir',
                                    lv: 'Papīra vākšana',
                                    lt: 'Popieriaus surinkimas',
                                    mt: 'Ħażna ta’ carta',
                                    nl: 'Papierinzameling',
                                    pl: 'Zbieranie papieru',
                                    pt: 'Coleta de papel',
                                    ro: 'Colectare de hârtie',
                                    sk: 'Zber papiera',
                                    sl: 'Zbiranje papirja',
                                    es: 'Recogida de papel',
                                    sv: 'Pappersinsamling',
                                    hu: 'Papírgolyászat',
                                },
                            },
                        },
                    },
                    astuccio: {
                        label: {
                            it: 'Astuccio',
                            en: 'Case',
                            de: 'Weinkiste',
                            fr: 'Coffret',
                            bg: 'Кейс', // Bulgaro
                            cs: 'Skříňka', // Ceco
                            hr: 'Pribor', // Croato
                            da: 'Æske', // Danese
                            et: 'Karp', // Estone
                            fi: 'Kotelo', // Finlandese
                            el: 'Θήκη', // Greco
                            ga: 'Cás', // Irlandese
                            lv: 'Kotse', // Lettone
                            lt: 'Kietuvėlis', // Lituano
                            mt: 'Każa', // Maltese
                            nl: 'Doos', // Neerlandese
                            pl: 'Pudełko', // Polacco
                            pt: 'Caixinha', // Portoghese
                            ro: 'Castrou', // Rumeno
                            sk: 'Skôpka', // Slovacco
                            sl: 'Kovana', // Sloveno
                            es: 'Estuche', // Spagnolo
                            sv: 'Etui', // Svedese
                            hu: 'Doboz', // Ungherese
                        },
                        materials: {
                            cartone: {
                                label: {
                                    it: 'Cartone',
                                    en: 'Cardboard',
                                    de: 'Karton',
                                    fr: 'Carton',
                                    bg: 'Картон', // Bulgaro
                                    cs: 'Kartón', // Ceco
                                    hr: 'Kartonska kutija', // Croato
                                    da: 'Karton', // Danese
                                    et: 'Karton', // Estone
                                    fi: 'Pahvi', // Finlandese
                                    el: 'Κάρτον', // Greco
                                    ga: 'Cartón', // Irlandese
                                    lv: 'Kartons', // Lettone
                                    lt: 'Kartonė', // Lituano
                                    mt: 'Kartun', // Maltese
                                    nl: 'Carton', // Neerlandese
                                    pl: 'Kartony', // Polacco
                                    pt: 'Carton', // Portoghese
                                    ro: 'Carton', // Rumeno
                                    sk: 'Kartón', // Slovacco
                                    sl: 'Karton', // Sloveno
                                    es: 'Cartón', // Spagnolo
                                    sv: 'Carton', // Svedese
                                    hu: 'Karton', // Ungherese
                                },
                                symbol: 'pap-20',
                                destination: {
                                    it: 'Raccolta carta',
                                    en: 'Paper collection',
                                    de: 'Papier Sammlung',
                                    fr: 'Collecte de papier',
                                    bg: 'Събиране на хартия',
                                    cs: 'Sběr papíru',
                                    hr: 'Sakupljanje papira',
                                    da: 'Pap- og papirindsamling',
                                    et: 'Paberikogumine',
                                    fi: 'Paperinkeräys',
                                    el: 'Συλλογή χαρτιού',
                                    ga: 'Bailiú páipéir',
                                    lv: 'Papīra vākšana',
                                    lt: 'Popieriaus surinkimas',
                                    mt: 'Ħażna ta’ carta',
                                    nl: 'Papierinzameling',
                                    pl: 'Zbieranie papieru',
                                    pt: 'Coleta de papel',
                                    ro: 'Colectare de hârtie',
                                    sk: 'Zber papiera',
                                    sl: 'Zbiranje papirja',
                                    es: 'Recogida de papel',
                                    sv: 'Pappersinsamling',
                                    hu: 'Papírgolyászat',
                                },
                            },
                        },
                    },
                }
            };
        },
        created() {

        },
        mounted() {

        },
        methods: {
            translateUrl(lang, wines) {
                const url = new URL(window.location.href);
                url.pathname = url.pathname.replace('/' + this.lang + '/', '/' + lang + '/');
                url.searchParams.delete('svl1z_hkqw');
                url.searchParams.set('manual_locale', '1');

                return url.toString();
            },
            openLanguageSelector() {
                this.languageSelectorOpened = true;
            },
            closeLanguageSelector() {
                this.languageSelectorOpened = false;
            },
        },
        computed: {
            productName() {
                return this.product['name'].replace('<br>', ' ')
            },
            combinationName() {
                if (!this.combination) {
                    return null;
                }
                return this.combination['attributes'].map(attr => `<strong>${attr.key_label}</strong>: ${attr.value_label}`).join('<span style="margin: 0 .4em;color:#8d5c65;opacity:.3">&bull;</span>');
            },
            combination() {
                if (this.combinationId) {
                    for (const combination of this.product.combinations) {
                        if (combination.code == this.combinationId) {
                            return combination;
                        }
                    }
                }
            },
            recycle() {
                if (this.combination && this.combination.recycle !== undefined) {
                    return this.combination.recycle;
                }
                return this.product.recycle;
            }
        }
    }

</script>

<style>

    .ls {
        background-color: #000000;
        border: 1px solid #fff;
        border-radius: .25rem;
        position: absolute;
        padding-top: 1rem;
        bottom: 0;
        width: 200px;
        translate: 0 100%;
        z-index: 100;
    }

    @media (min-width:1000px) {
        .ls {
            left: 0;
        }
    }
    @media (max-width:1000px) {
        .ls {
            right: 0;
        }
    }

    .bottle{
        max-width: 70%;
        width:100%;
        object-fit:contain;
        object-position: left bottom;
        height: auto;
    }

    @media (max-width:1279px) {
        .bottle{
            width: 600px;
        }
    }

    @media (min-width:1500px) {
        .bottle{
            max-width: 60%;
        }
    }

    body, html {
        letter-spacing: 1px;
    }

    h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1{
        font-weight: 700;
    }

    [alt="simbolo"] {
        filter: invert(1);
    }

    @media (min-width:1800px) {

        .recycle-block .h1-like-text{
            font-size: 3.5rem
        }
    }

    @media (max-width:1440px) {
        .recycle-block .h1-like-text{
            font-size: 3.5rem
        }
    }

    @media (max-width:1199px) {
        .recycle-block .h1-like-text{
            font-size: 3.5rem
        }
    }

    @media (max-width:991px) {
        .recycle-block .h1-like-text{
            font-size: 3.4rem
        }
    }

    @media (max-width:575px) {
        .recycle-block .h1-like-text{
            font-size: 2.7rem
        }
    }

    @media (max-width:430px) {
        .recycle-block .h1-like-text{
            font-size: 2.4rem
        }
    }

    .recycle-block p{
        max-width:70ch;
        padding-left:15px;
        padding-right: 15px;
    }

    .shop-single-item__content.recycle{
        max-width: 100%;
    }

    th span, td span, .table-mobile *{font-family: "europa", sans-serif;}

    .bg-gold{
        background-color:#b6975c;
    }

    @media (min-width: 1280px) {
        .ml-xl-0{
            margin-left: 0px !important
        }
    }

    .bg-lightgold{
        background-color: rgba(255, 255, 255, 0.06);
    }

    .h6{
        margin-bottom: 0px;
    }

    .table th{
        background: #000000;
    }

    .table td, .table th{
        border: 0px;
        vertical-align: middle;
    }

    .table td{
        background: transparent !important;
    }

    .table > tbody > tr:nth-of-type(odd) {
        background-color: transparent;
    }

    .table > tbody > tr:nth-of-type(even) {
        background-color: rgba(255, 255, 255, 0.06);
    }

    .shop-like-header__gold-text:after{
        display:none;
    }
    .shop-like-header__gold-text{
        border: 0px !important;
        padding: 0px;
    }

    @media (max-width: 767px){
        .gold-like-title {
            font-size: 1.2rem;
        }
    }

    .content-td{
        max-width: 65%;
    }

    .table-mobile{
        width: calc(100% - 30px);
        max-width: 400px;
    }

    @media (max-width: 420px) {
        .table-mobile{
            max-width: 420px;
        }
    }

    .align-control{
        text-align: center;
    }

    .justify-control{
        justify-content: center;
    }

    @media (min-width: 1200px) {
        .align-control{
            text-align: left;
        }
        .justify-control{
            justify-content: flex-start;
        }
    }

    .logo{
        height:25px;
        max-width: 90%;
    }

    hr:not([size]) {
        height: 1px;
        width: 100%;
        background: white;
        opacity: .2;
    }

</style>
